
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

namespace WebApi {
    export const Version = '1.0.0.0';
    export interface ApiTSHandlersCallbacks<T> {
        Then?: (res: T) => void;
        Catch?: (error?: string) => void;
        Finally?: (res?: T) => void;
        BeforeCall?: (abortController?: AbortController) => void;
    }
    export interface KeyValuePair<K, V>{
        Key: K;
        Value: V;
    }
    export type Dict<TValue> = {
        [key: string]: TValue;
    }
    export type DictN<TValue> = {
        [key: number]: TValue;
    }
    export type TFileStreamHeaders = {
        filename?: string;
        size?: number;
    } & Dict<any>; 
    export type Guid = string;
    export let timeout: number = 0;
    export let debug: boolean = false;
    export let isUseTimeUTC = false;
    //export let isServiceLocalTimeZone = true; //true: send local, false: send UTC
    //export let serviceTimeZoneOffset = 0; //utc;
    export function getTzOffset(date: Date = new Date()) : number {
        return date.getTimezoneOffset() * -1;
    }
    function timeZoneOffsetToStr(offset: number) : string {
        const offsetAbs = Math.abs(offset);
        let hours = Math.floor(offsetAbs / 60);
        let minutes = offsetAbs % 60;

        let hs = hours.toString();
        if (hours == 0) {
            hs = '00';
        }
        else if (hours > 0 && hs.length < 2) {
            hs = '0' + hours;
        }
        let mins = minutes.toString();
        if (minutes == 0) {
            mins = '00';
        }
        else if (minutes > 0 && mins.length < 2) {
            mins = '0' + minutes;
        }
        return `${offset >= 0 ? '+':'-'}${hs}${mins}`;
    }
    export let serviceName: string = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')+'/api.svc';
    export let serviceUrl: string = '';
    export const Guid = {
        Empty: '00000000-0000-0000-0000-000000000000',
        Generate(): string {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        },
    };
    export const Console : {ColorSend: string, ColorResult: string, ColorBG: string} = {
        ColorSend: '#11793E',
        ColorResult: '#000',
        ColorBG: 'antiquewhite'
    };
    export let debugExcludes: Dict<boolean> = {};
    //export debugExcludesEmptyOnly: any false;
    export let ontimeout = function(method: string, e?: ProgressEvent) : void {

    };
    export let onUnauth = function(method?: string) : void {
        console.log('Unauthorized '+method);
        if ((<any>window)['Luff'] && (<any>window)['Luff'].User)
            localStorage.setItem('LuffRoute'+document.location.href.split('#')[0], document.location.hash);
        window.location.href = 'index.html'
    };
    export let onDeny = function(method: string, params: object) : void {
        console.error('[Server] Method Access denied '+ method, params);
        if ((<any>window)['Luff'])
            (<any>window)['Luff'].Pop.Error('[Access denied] Method: `' + method + '` is not allowed');
    };
    let base64: any = (function(){function b(m: any,n: any,o: any,p: any,q: any,r: any){m+='';for(var y,t=0,u=0,v=m.length,w='',x=0;u<v;){for(y=m.charCodeAt(u),y=256>y?o[y]:-1,t=(t<<q)+y,x+=q;x>=r;){x-=r;var z=t>>x;w+=p.charAt(z),t^=z<<x}++u}return!n&&0<x&&(w+=p.charAt(t<<r-x)),w}for(var k,d='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',e='',f=[256],g=[256],h=0,j={encode:function encode(m: any){var n=m.replace(/[\u0080-\u07ff]/g,function(o: any){var p=o.charCodeAt(0);return String.fromCharCode(192|p>>6,128|63&p)}).replace(/[\u0800-\uffff]/g,function(o: any){var p=o.charCodeAt(0);return String.fromCharCode(224|p>>12,128|63&p>>6,128|63&p)});return n},decode:function decode(m: any){var n=m.replace(/[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,function(o: any){var p=(15&o.charCodeAt(0))<<12|(63&o.charCodeAt(1))<<6|63&o.charCodeAt(2);return String.fromCharCode(p)}).replace(/[\u00c0-\u00df][\u0080-\u00bf]/g,function(o: any){var p=(31&o.charCodeAt(0))<<6|63&o.charCodeAt(1);return String.fromCharCode(p)});return n}};256>h;)k=String.fromCharCode(h),e+=k,g[h]=h,f[h]=d.indexOf(k),++h;let l:any=function(m: any,n: any,o: any){return n?l[m](n,o):m?null:this};return l.btoa=l.encode=function(m: any,n:any){return m=!1===l.raw||l.utf8encode||n?j.encode(m):m,m=b(m,!1,g,d,8,6),m+'===='.slice(m.length%4||4)},l.atob=l.decode=function(m:any,n:any){m=(m+'').split('=');var o=m.length;do--o,m[o]=b(m[o],!0,f,e,6,8);while(0<o);return m=m.join(''),!1===l.raw||l.utf8decode||n?j.decode(m):m},l})();
    function make_base_auth(user: string, password: string) : string {
        let tok = user + ':' + password;
        let hash = base64.encode(tok);
        return 'Basic ' + hash;
    }

    
    function _objectClone<T>(e: T) : T {return {...e}}
    function clone<T>(object: T) : T {
        let obj = <any>object;
        if(typeof obj !== 'object' || obj === null || object instanceof File || object instanceof Blob) {
            return obj;
        }
        //let x = Object.getOwnPropertyNames(obj);

        //if(obj instanceof LureDate) {
        //    return <any>new LureDate(obj.TotalMilliseconds);
        //}
        if(obj instanceof Date) {
            return <any>new Date(obj.getTime());
        }
        if(obj instanceof Array) {
            return obj.reduce((arr, item, i) => {
                arr[i] = clone(item);
                return arr;
            }, []);
        }

        if(obj instanceof Object) {
            return Object.getOwnPropertyNames(obj).reduce((newObj: any, key: string) => {
                newObj[key] = clone<any>(obj[key]);
                return <any>newObj;
            }, {})
        }
    }
    function _isObjectEmpty(obj: any, isStrict: boolean = false){
        if (isStrict && typeof obj !== 'object')
            return false;
        return !(obj && Object.keys(obj).length > 0);
    }
    function Handle<T>(promise: Promise<T>, handlers: ApiTSHandlersCallbacks<T> = {} ) : Promise<T> {
        return promise.then(function(x){
            handlers.Then ? handlers.Then(x): null;
            handlers.Finally ?  handlers.Finally(x) : null;
            return promise;
        })
            .catch(function(x){
                handlers.Catch ? handlers.Catch(x): console.error('[api.handle]', x);
                handlers.Finally ?  handlers.Finally(x) : null;
                return promise;
            });
    }
    function ConsoleResult(callFnName: string, result: any) : void {
        if ((debug || (typeof (<any>window)['DEBUG'] !== 'undefined' && (<any>window)['DEBUG']) ) && ( Object.getOwnPropertyNames(debugExcludes).indexOf(callFnName) < 0 || (debugExcludes[callFnName] && !_isObjectEmpty(result, true)) ))
        {
            let SpaceCount = 36-callFnName.length;
            console.log('%c[api] '+callFnName+' '.repeat(SpaceCount>0? SpaceCount: 1)+'<- ', `color: ${Console.ColorResult}; background-color: ${Console.ColorBG}; padding: 3px 7px;`,  result);
        }
        return result;
    }


    export let onerror = function(ev: ProgressEvent | null, method: string, params: object, xhr: Response) : void {
        console.error(ev, method, params, xhr);
    };
    type TFormFile = {
        parameterName: string;
        files: File[];
    }
    type TCallProps<T> = {
        controller: string;
        controllerPath: string;
        controllerMethod: string;
        uriParams: string;
        method: string;
        params: any;
        files: TFormFile[];
        isReturnStream: boolean;
        handlers: ApiTSHandlersCallbacks<T>;
    }
    export function toJSON(obj: any) : string {
        return JSON.stringify(obj, JSON_replacer);
    }
    export function fromJSON<T>(json: string) : T {
        return JSON.parse(json, JSON_reviver);
    }
    export type IActionResult = any;
    export type ActionResult = IActionResult;
    export type ContentResult = string;
    export type Task = void;
    export interface AuthPack { 
        AccessToken: string;
        RefreshToken: Guid;
        RefreshExpiresInSeconds: number;
    }
    export let token: string = localStorage.getItem("token") ?? "";
    let pendingRefresh: Promise<AuthPack> = null;
    export function setTokens(tokenPack: AuthPack) {
        localStorage.setItem("token", tokenPack.AccessToken);
        localStorage.setItem("token_refresh", tokenPack.RefreshToken);
        localStorage.setItem("token_expires_in", tokenPack.RefreshExpiresInSeconds.toString());
        token = tokenPack.AccessToken;
    }
    export function parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }
    function retryLogin<T>(prevFetch: () => Promise<T>, method: string) : Promise<T> {
        if (!pendingRefresh) {
            pendingRefresh = WebApi.Login_Refresh(localStorage.getItem("token_refresh"));
        }
        if (pendingRefresh) {
            return new Promise((resolve, reject) => {
                pendingRefresh
                    .then(tt => {
                        if (!tt)
                            throw new Error();
                        setTokens(tt);
                        pendingRefresh = null;
                        return prevFetch().then(x => {
                            resolve(x)
                        });
                    })
                    .catch(() => {
                        onUnauth(method);
                        return reject("token refresh failed");
                    })
            })

        }
    }
    export function LogIn(login: string, pass: string, isRememberMe: boolean, onSuccess?: () => void, onFail?: (errText) => void) : Promise<number> {
        return Login_Authenticate(login, pass, isRememberMe)
            .then(tokenPack => {
                setTokens(tokenPack);
                if (onSuccess)
                    onSuccess();
                else
                    document.location.href = "./";
                return 1;
            })
            .catch(e => {
                if (onFail)
                    onFail(e);
                return -1;
            })
    }
    export function LogOut() : Promise<number> {
        return Login_LogOut(localStorage.getItem("token_refresh"))
            .finally(() => {
                localStorage.removeItem("token");
                localStorage.removeItem("token_refresh");
                localStorage.removeItem("token_expires_in");
                onUnauth('LogOut');
                return 1;
            });
    }
    export function LogRefresh() : Promise<number> {
        return Login_Refresh(localStorage.getItem("token_refresh"))
            .then(tokenPack => {
                setTokens(tokenPack);
                return 1;
            })
            .catch(() => {
                localStorage.removeItem("token");
                localStorage.removeItem("token_refresh");
                localStorage.removeItem("token_expires_in");
                onUnauth('LogRefresh');
                return -1;
            })
    }
    export function LogAs(loginOrId: string | number) : Promise<number> {
        let p: Promise<AuthPack>;
        if (typeof loginOrId == 'number') {
            p = Login_As(loginOrId);
        }
        else {
            p = Login_AsByLogin(loginOrId as string);
        }
        return p
            .then(tokenPack => {
                setTokens(tokenPack);
                document.location.reload();
                return 1;
            })
            .catch(e => {
                console.error(e);
                return -1;
            })
    }
    export function ApiFetch<T>(props: TCallProps<T>) : Promise<T> {
        const callFnName = `${props.controller}_${props.controllerMethod} (${props.method})`;

        if (debug && ( Object.getOwnPropertyNames(debugExcludes).indexOf(callFnName) < 0 )){
            let SpaceCount = 36-callFnName.length;
            let hasBody = !!props.params;
            let hasUri = props.uriParams && props.uriParams.length && props.uriParams.indexOf('?') > -1;
            let args = [
                '%c[api] '+callFnName+' '.repeat(SpaceCount>0? SpaceCount: 1)+'-> ',
                `color: ${Console.ColorSend}; background-color: ${Console.ColorBG}; padding: 3px 7px;`
            ];
            if (hasBody)
                args.push(props.params);
            if (hasUri){
                args.push(props.uriParams.substring(props.uriParams.indexOf('?') + 1))
            }
            console.log.call(null, ...args);
        }

        let body : any;

        let headers : Dict<string> = {
            'Authorization': `Bearer ${token}`
        };

        if (props.files.length > 0) {
            let data = new FormData();
            for (let formFile of props.files) {
                for (let file of formFile.files) {
                    data.append(formFile.parameterName, file);
                }
            }
            body = data;
        } else {
            body = toJSON(props.params);
            headers['Content-Type'] = 'application/json';
        }

        let signal;
        if (props.handlers?.BeforeCall) {
            const c = new AbortController();
            signal = c.signal;
            props.handlers.BeforeCall(c)
        }
        const fetchResult = fetch(serviceUrl + "/" + props.controllerPath + props.uriParams, {
            method: props.method,
            headers: headers,
            body: body,
            signal: signal
        })
            .then(r => {
                if (r.status == 200) {
                    const responseContentType = r.headers.get('Content-Type');
                    if (responseContentType == 'application/octet-stream') {
                        props.isReturnStream = true;
                    }
                    //console.log(`r.headers.get('Content-Type')`, responseContentType);

                    if (!props.isReturnStream) {
                        return r.text().then(result => {
                            if (responseContentType && !responseContentType.includes('text/')){
                                result = result.length > 0 ? fromJSON(result) : void 0;
                            }
                            ConsoleResult(callFnName, result);
                            return result as any;
                        })
                    }
                    // r.body.getReader().read().then(body => {
                    //     ConsoleResult(callFnName, body);
                    //     return body;
                    // });
                    return r.blob().then(blob => {
                        ConsoleResult(callFnName, blob);
                        return blob as any;
                    });
                }
                // else if (r.status === 204){
                //     console.error('[api '+callFnName+'] Error 204: Empty');
                //     if (onerror)
                //         onerror(null, callFnName, props.params, r);
                // }
                else if (r.status === 403){
                    console.error('[api '+callFnName+'] Error 403: Forbidden');
                    if (onerror)
                        onerror(null, callFnName, props.params, r);
                    if (onDeny)
                        onDeny(callFnName, props.params)
                }
                else if (r.status === 401)
                {
                    return retryLogin(() => ApiFetch(props), callFnName)
                }
                else {
                    try {
                        if (props.controllerPath == "api/Login") {
                            return new Promise((_, reject ) => r.text().then(t => reject(t))) as Promise<T>;
                        }
                        r.text()
                          .then(t => {
                              console.error('[api '+ callFnName+'] Error '+ r.status + ': ' + r.statusText, '\n', t);
                          })
                    } catch (e) {
                        console.error('[api '+ callFnName+'] Error '+ r.status + ': ' + r.statusText);
                    }
                    finally {
                        if (onerror)
                            onerror(null, callFnName, props.params, r);
                    }
                }
                throw new Error('another error');
            });
            //.catch((e) => {
            //    if (onerror)
            //        onerror(e, callFnName, props.params, null);
            //});
        return Handle(fetchResult, props.handlers);
    }

    function formatZero(value: number, count: number = 2) : string {
        let sValue = value.toString();
        const len = sValue.length;

        return '0'.repeat(count - len) + sValue;
    }
    function dateToString(d: Date) : string {
        if (!d)
            return null;
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const day = d.getDate();

        const hour = d.getHours();
        const min = d.getMinutes();
        const sec = d.getSeconds();
        const ms = d.getMilliseconds();

        const utcFlag = isUseTimeUTC ? 'Z':'';

        return `${year}-${formatZero(month)}-${formatZero(day)}T${formatZero(hour)}:${formatZero(min)}:${formatZero(sec)}.${formatZero(ms, 3)}${utcFlag}`
    }
    function JSON_replacer(key, value) {
            if (value instanceof Date) {
                if (!isUseTimeUTC)
                    return dateToString(value);

                return value.toISOString();
            }
            return value;
    }
    //const rgxDateISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(Z|([+\-])(\d{2}):(\d{2}))?$/;
    const rgxDateISO = /^(\d{4})-(\d{2})-(\d{2})(T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?))?(Z|([+\-])(\d{2}):(\d{2}))?$/;
    const rgxDateTzISO = /(Z|([+\-])(\d{2}):(\d{2}))/;
    function JSON_reviver(key, value) {
        if (rgxDateISO.test(value)) {
            if (isUseTimeUTC) {
                return new Date(value.replace(rgxDateTzISO, ""));
            }
            if (value.length <= 10) // if without time, then prevent adding timezone hours. Otherwise new Date('2026-03-12') will be: Thu Mar 12 2026 03:00:00 GMT+0300
                value += ' 00:00:00';
            return new Date(value);
        }
        return value;
    }
    //export function Logout() {
    //  token = void 0;
    //  localStorage.removeItem('token');
    //  document.location.href = '/auth.html';
    //}

  export function AppsHost_Get(fileName: string, handlers?: ApiTSHandlersCallbacks<Blob>): Promise<Blob> { 
    return ApiFetch({                             
        controller: `AppsHost`,                            
        controllerPath: `Apps`,            
        controllerMethod: `Get`,                              
        uriParams: `/${fileName}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: true,
        handlers: handlers,                                        
    }); 
  }
  export function AppsHost_GetList( handlers?: ApiTSHandlersCallbacks<string[]>): Promise<string[]> { 
    return ApiFetch({                             
        controller: `AppsHost`,                            
        controllerPath: `Apps`,            
        controllerMethod: `GetList`,                              
        uriParams: `/list`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function AppsHost_Add(file: File, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `AppsHost`,                            
        controllerPath: `Apps`,            
        controllerMethod: `Add`,                              
        uriParams: `?file=${file}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'file', files: [file]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function AppsHost_Delete(fileName: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `AppsHost`,                            
        controllerPath: `Apps`,            
        controllerMethod: `Delete`,                              
        uriParams: `?fileName=${encodeURIComponent(fileName)}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Video_UploadVideo( file: File, groupId: number, replaceFileId: Guid, handlers?: ApiTSHandlersCallbacks<ResultSet<AttachFileAutoDTO>>): Promise<ResultSet<AttachFileAutoDTO>> { 
    return ApiFetch({                             
        controller: `Video`,                            
        controllerPath: `api/Video`,            
        controllerMethod: `UploadVideo`,                              
        uriParams: `?groupId=${groupId}&replaceFileId=${replaceFileId}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'file', files: [file]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function VideoHlsPath_Get(uid: Guid, handlers?: ApiTSHandlersCallbacks<string>): Promise<string> { 
    return ApiFetch({                             
        controller: `VideoHlsPath`,                            
        controllerPath: `api/VideoHlsPath`,            
        controllerMethod: `Get`,                              
        uriParams: `?uid=${uid}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DevicesPendingKey_Get( handlers?: ApiTSHandlersCallbacks<string>): Promise<string> { 
    return ApiFetch({                             
        controller: `DevicesPendingKey`,                            
        controllerPath: `api/DevicesPendingKey`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Licenses_Get( handlers?: ApiTSHandlersCallbacks<NetworkLicenseDTO[]>): Promise<NetworkLicenseDTO[]> { 
    return ApiFetch({                             
        controller: `Licenses`,                            
        controllerPath: `api/Licenses`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_Authenticate(login: string, pass: string, isrememberme: boolean, handlers?: ApiTSHandlersCallbacks<AuthResultPack>): Promise<AuthResultPack> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `Authenticate`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: { Login: login, Pass: pass, IsRememberMe: isrememberme },          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_AuthCheck( handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `AuthCheck`,                              
        uriParams: `/authCheck`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_ChangePass(newPass: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `ChangePass`,                              
        uriParams: `/ChangePass`,                             
        method: 'POST',                                    
        params: newPass,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_Refresh(refreshToken: Guid, handlers?: ApiTSHandlersCallbacks<AuthResultPack>): Promise<AuthResultPack> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `Refresh`,                              
        uriParams: `/Refresh`,                             
        method: 'POST',                                    
        params: refreshToken,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_LogOut(refreshToken: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `LogOut`,                              
        uriParams: `/LogOut`,                             
        method: 'POST',                                    
        params: refreshToken,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_As(loginID: number, handlers?: ApiTSHandlersCallbacks<AuthPack>): Promise<AuthPack> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `As`,                              
        uriParams: `/LoginAsById?loginID=${loginID}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Login_AsByLogin(login: string, handlers?: ApiTSHandlersCallbacks<AuthPack>): Promise<AuthPack> { 
    return ApiFetch({                             
        controller: `Login`,                            
        controllerPath: `api/Login`,            
        controllerMethod: `AsByLogin`,                              
        uriParams: `/LoginAsByLogin?login=${encodeURIComponent(login)}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function NetworkData_Get( handlers?: ApiTSHandlersCallbacks<NetworkDataDTO>): Promise<NetworkDataDTO> { 
    return ApiFetch({                             
        controller: `NetworkData`,                            
        controllerPath: `api/NetworkData`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function XlsxToHtml_Convert(xlsx: File, handlers?: ApiTSHandlersCallbacks<ContentResult>): Promise<ContentResult> { 
    return ApiFetch({                             
        controller: `XlsxToHtml`,                            
        controllerPath: `api/XlsxToHtml`,            
        controllerMethod: `Convert`,                              
        uriParams: `?xlsx=${xlsx}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'xlsx', files: [xlsx]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function XlsxGenExport_Get(pack: SummaryXlsxGenPack, handlers?: ApiTSHandlersCallbacks<Blob>): Promise<Blob> { 
    return ApiFetch({                             
        controller: `XlsxGenExport`,                            
        controllerPath: `api/XlsxGenExport`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: pack,          
        files: [],      
        isReturnStream: true,
        handlers: handlers,                                        
    }); 
  }
  export function AttachFiles_GetFile(content: string, handlers?: ApiTSHandlersCallbacks<IActionResult>): Promise<IActionResult> { 
    return ApiFetch({                             
        controller: `AttachFiles`,                            
        controllerPath: `AttachFiles`,            
        controllerMethod: `GetFile`,                              
        uriParams: `/${content}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function AttachFiles_UploadFile(file: File, handlers?: ApiTSHandlersCallbacks<AttachFileAutoDTO>): Promise<AttachFileAutoDTO> { 
    return ApiFetch({                             
        controller: `AttachFiles`,                            
        controllerPath: `AttachFiles`,            
        controllerMethod: `UploadFile`,                              
        uriParams: `?file=${file}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [{parameterName: 'file', files: [file]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function AttachFiles2_GetFile(content: string, handlers?: ApiTSHandlersCallbacks<IActionResult>): Promise<IActionResult> { 
    return ApiFetch({                             
        controller: `AttachFiles2`,                            
        controllerPath: `/screen/AttachFiles`,            
        controllerMethod: `GetFile`,                              
        uriParams: `/${content}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function NetworkSpaceUsed_Get( handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `NetworkSpaceUsed`,                            
        controllerPath: `api/NetworkSpaceUsed`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentSizeByBroadcastId_Get(broadcastId: number, handlers?: ApiTSHandlersCallbacks<ContentSizeSet>): Promise<ContentSizeSet> { 
    return ApiFetch({                             
        controller: `ContentSizeByBroadcastId`,                            
        controllerPath: `api/ContentSizeByBroadcastId`,            
        controllerMethod: `Get`,                              
        uriParams: `?broadcastId=${broadcastId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentSizeByDialyBlocks_Get(blockIds: number[], handlers?: ApiTSHandlersCallbacks<ContentSizeSet>): Promise<ContentSizeSet> { 
    return ApiFetch({                             
        controller: `ContentSizeByDialyBlocks`,                            
        controllerPath: `api/ContentSizeByDialyBlocks`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: blockIds,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentSizeByTemplates_Get(templateIds: number[], handlers?: ApiTSHandlersCallbacks<ContentSizeSet>): Promise<ContentSizeSet> { 
    return ApiFetch({                             
        controller: `ContentSizeByTemplates`,                            
        controllerPath: `api/ContentSizeByTemplates`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: templateIds,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentVideoHls_Update(fileId: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `ContentVideoHls`,                            
        controllerPath: `api/ContentVideoHls`,            
        controllerMethod: `Update`,                              
        uriParams: `?fileId=${fileId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentList_Get(templateId: number, broadcastId: number, isSkipContentFiles: boolean, quality: string, lastCheckDateUtc: Date, handlers?: ApiTSHandlersCallbacks<ContentFilesSet>): Promise<ContentFilesSet> { 
    return ApiFetch({                             
        controller: `ContentList`,                            
        controllerPath: `api/ContentList`,            
        controllerMethod: `Get`,                              
        uriParams: `?templateId=${templateId ?? ""}&broadcastId=${broadcastId ?? ""}&isSkipContentFiles=${isSkipContentFiles}&quality=${encodeURIComponent(quality)}&lastCheckDateUtc=${dateToString(lastCheckDateUtc) ?? ""}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentConfiguration_Get(templateId: number, broadcastId: number, handlers?: ApiTSHandlersCallbacks<WsmContentConfigurationData>): Promise<WsmContentConfigurationData> { 
    return ApiFetch({                             
        controller: `ContentConfiguration`,                            
        controllerPath: `api/ContentConfiguration`,            
        controllerMethod: `Get`,                              
        uriParams: `?templateId=${templateId ?? ""}&broadcastId=${broadcastId ?? ""}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ContentConfiguration_GetDailyBlockPreview(dialyBlockId: number, handlers?: ApiTSHandlersCallbacks<WsmContentConfigurationData>): Promise<WsmContentConfigurationData> { 
    return ApiFetch({                             
        controller: `ContentConfiguration`,                            
        controllerPath: `api/ContentConfiguration`,            
        controllerMethod: `GetDailyBlockPreview`,                              
        uriParams: `/dialypreview?dialyBlockId=${dialyBlockId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StartPack_Get( handlers?: ApiTSHandlersCallbacks<StartPack>): Promise<StartPack> { 
    return ApiFetch({                             
        controller: `StartPack`,                            
        controllerPath: `api/StartPack`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Users_Get( handlers?: ApiTSHandlersCallbacks<NetworkUserDTO[]>): Promise<NetworkUserDTO[]> { 
    return ApiFetch({                             
        controller: `Users`,                            
        controllerPath: `api/Users`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Users_Add(user: NetworkUserCreateDTO, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Users`,                            
        controllerPath: `api/Users`,            
        controllerMethod: `Add`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: user,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Users_Update(user: NetworkUserDTO, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Users`,                            
        controllerPath: `api/Users`,            
        controllerMethod: `Update`,                              
        uriParams: ``,                             
        method: 'PUT',                                    
        params: user,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Users_Delete(loginId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Users`,                            
        controllerPath: `api/Users`,            
        controllerMethod: `Delete`,                              
        uriParams: `?loginId=${loginId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Users_LoginAs(loginId: number, handlers?: ApiTSHandlersCallbacks<AuthResultPack>): Promise<AuthResultPack> { 
    return ApiFetch({                             
        controller: `Users`,                            
        controllerPath: `api/Users`,            
        controllerMethod: `LoginAs`,                              
        uriParams: `/loginAs?loginId=${loginId}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function UserActions_Get(skip: number, take: number, subActionType: string, searchText: string, handlers?: ApiTSHandlersCallbacks<UserActionDTO[]>): Promise<UserActionDTO[]> { 
    return ApiFetch({                             
        controller: `UserActions`,                            
        controllerPath: `api/UserActions`,            
        controllerMethod: `Get`,                              
        uriParams: `?skip=${skip}&take=${take}&subActionType=${encodeURIComponent(subActionType)}&searchText=${encodeURIComponent(searchText)}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function NetworkDevicePoster_Get( handlers?: ApiTSHandlersCallbacks<AttachFileAutoDTO>): Promise<AttachFileAutoDTO> { 
    return ApiFetch({                             
        controller: `NetworkDevicePoster`,                            
        controllerPath: `api/NetworkDevicePoster`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function NetworkDevicePoster_Set(posterId: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `NetworkDevicePoster`,                            
        controllerPath: `api/NetworkDevicePoster`,            
        controllerMethod: `Set`,                              
        uriParams: `?posterId=${posterId ?? ""}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeed_Get( handlers?: ApiTSHandlersCallbacks<RssFeedAutoDTO[]>): Promise<RssFeedAutoDTO[]> { 
    return ApiFetch({                             
        controller: `RssFeed`,                            
        controllerPath: `api/RssFeed`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeed_GetLite( handlers?: ApiTSHandlersCallbacks<RssFeedShort[]>): Promise<RssFeedShort[]> { 
    return ApiFetch({                             
        controller: `RssFeed`,                            
        controllerPath: `api/RssFeed`,            
        controllerMethod: `GetLite`,                              
        uriParams: `/short`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeed_AddUpdate(rssId: Guid, src: string, name: string, moderationMode: RssModerationType, postLimit: number, handlers?: ApiTSHandlersCallbacks<Guid>): Promise<Guid> { 
    return ApiFetch({                             
        controller: `RssFeed`,                            
        controllerPath: `api/RssFeed`,            
        controllerMethod: `AddUpdate`,                              
        uriParams: `?rssId=${rssId}&src=${encodeURIComponent(src)}&name=${encodeURIComponent(name)}&moderationMode=${moderationMode}&postLimit=${postLimit}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeed_Remove(rssId: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `RssFeed`,                            
        controllerPath: `api/RssFeed`,            
        controllerMethod: `Remove`,                              
        uriParams: `?rssId=${rssId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeedItem_Get(feedId: Guid, isModeratedOnly: boolean, handlers?: ApiTSHandlersCallbacks<RssFeedItemAutoDTO[]>): Promise<RssFeedItemAutoDTO[]> { 
    return ApiFetch({                             
        controller: `RssFeedItem`,                            
        controllerPath: `api/RssFeedItem`,            
        controllerMethod: `Get`,                              
        uriParams: `?feedId=${feedId}&isModeratedOnly=${isModeratedOnly}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeedItem_Update(postId: number, title: string, description: string, imageUrl: string, isModerated: boolean, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `RssFeedItem`,                            
        controllerPath: `api/RssFeedItem`,            
        controllerMethod: `Update`,                              
        uriParams: `?postId=${postId}&title=${encodeURIComponent(title)}&description=${encodeURIComponent(description)}&imageUrl=${encodeURIComponent(imageUrl)}&isModerated=${isModerated}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function RssFeedItemIsModerated_Set(postId: number, isModerated: boolean, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `RssFeedItemIsModerated`,                            
        controllerPath: `api/RssFeedItemIsModerated`,            
        controllerMethod: `Set`,                              
        uriParams: `?postId=${postId}&isModerated=${isModerated}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSetItems_Get(setId: Guid, handlers?: ApiTSHandlersCallbacks<PriceSetItemAutoDTO[]>): Promise<PriceSetItemAutoDTO[]> { 
    return ApiFetch({                             
        controller: `PriceSetItems`,                            
        controllerPath: `api/PriceSetItems`,            
        controllerMethod: `Get`,                              
        uriParams: `?setId=${setId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSetItems_Add(setId: Guid, dto: PriceSetItemAutoDTO, handlers?: ApiTSHandlersCallbacks<PriceSetItemAutoDTO>): Promise<PriceSetItemAutoDTO> { 
    return ApiFetch({                             
        controller: `PriceSetItems`,                            
        controllerPath: `api/PriceSetItems`,            
        controllerMethod: `Add`,                              
        uriParams: `?setId=${setId}`,                             
        method: 'POST',                                    
        params: dto,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSetItems_Update(dto: PriceSetItemAutoDTO, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `PriceSetItems`,                            
        controllerPath: `api/PriceSetItems`,            
        controllerMethod: `Update`,                              
        uriParams: ``,                             
        method: 'PUT',                                    
        params: dto,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSetItems_Delete(id: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `PriceSetItems`,                            
        controllerPath: `api/PriceSetItems`,            
        controllerMethod: `Delete`,                              
        uriParams: `?id=${id}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSetItemsXLSX_Get(setId: Guid, handlers?: ApiTSHandlersCallbacks<Blob>): Promise<Blob> { 
    return ApiFetch({                             
        controller: `PriceSetItemsXLSX`,                            
        controllerPath: `api/PriceSetItemsXLSX`,            
        controllerMethod: `Get`,                              
        uriParams: `?setId=${setId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: true,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSetItemsXLSX_Set(setId: Guid, xlsx: File, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `PriceSetItemsXLSX`,                            
        controllerPath: `api/PriceSetItemsXLSX`,            
        controllerMethod: `Set`,                              
        uriParams: `?setId=${setId}&xlsx=${xlsx}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'xlsx', files: [xlsx]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSets_Get( handlers?: ApiTSHandlersCallbacks<PriceSetDto[]>): Promise<PriceSetDto[]> { 
    return ApiFetch({                             
        controller: `PriceSets`,                            
        controllerPath: `api/PriceSets`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSets_Add(name: string, xlsx: File, handlers?: ApiTSHandlersCallbacks<PriceSetDto>): Promise<PriceSetDto> { 
    return ApiFetch({                             
        controller: `PriceSets`,                            
        controllerPath: `api/PriceSets`,            
        controllerMethod: `Add`,                              
        uriParams: `?name=${encodeURIComponent(name)}&xlsx=${xlsx}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'xlsx', files: [xlsx]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSets_Update(priceSetId: Guid, name: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `PriceSets`,                            
        controllerPath: `api/PriceSets`,            
        controllerMethod: `Update`,                              
        uriParams: `?priceSetId=${priceSetId}&name=${encodeURIComponent(name)}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PriceSets_Delete(priceSetId: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `PriceSets`,                            
        controllerPath: `api/PriceSets`,            
        controllerMethod: `Delete`,                              
        uriParams: `?priceSetId=${priceSetId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function TemplateExport_Get(templateId: number, handlers?: ApiTSHandlersCallbacks<Blob>): Promise<Blob> { 
    return ApiFetch({                             
        controller: `TemplateExport`,                            
        controllerPath: `api/TemplateExport`,            
        controllerMethod: `Get`,                              
        uriParams: `?templateId=${templateId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function TemplateImport_Add(templateJsonFile: File, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `TemplateImport`,                            
        controllerPath: `api/TemplateImport`,            
        controllerMethod: `Add`,                              
        uriParams: `?templateJsonFile=${templateJsonFile}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'templateJsonFile', files: [templateJsonFile]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Templates_Get(groupId: number, searchText: string, skip: number, take: number, sortOrderType: TemplateSortOrderType, isSortDesc: boolean, dateFrom: Date, dateTo: Date, handlers?: ApiTSHandlersCallbacks<TemplateAutoDTO[]>): Promise<TemplateAutoDTO[]> { 
    return ApiFetch({                             
        controller: `Templates`,                            
        controllerPath: `api/Templates`,            
        controllerMethod: `Get`,                              
        uriParams: `?groupId=${groupId ?? ""}&searchText=${encodeURIComponent(searchText)}&skip=${skip}&take=${take}&sortOrderType=${sortOrderType}&isSortDesc=${isSortDesc}&dateFrom=${dateToString(dateFrom) ?? ""}&dateTo=${dateToString(dateTo) ?? ""}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Templates_ShortGet(searchText: string, skip: number, take: number, isIncludeThumbs: boolean, handlers?: ApiTSHandlersCallbacks<TemplateShort[]>): Promise<TemplateShort[]> { 
    return ApiFetch({                             
        controller: `Templates`,                            
        controllerPath: `api/Templates`,            
        controllerMethod: `ShortGet`,                              
        uriParams: `/short?searchText=${encodeURIComponent(searchText)}&skip=${skip}&take=${take}&isIncludeThumbs=${isIncludeThumbs}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Templates_GetOne(templateId: number, handlers?: ApiTSHandlersCallbacks<TemplateAutoDTO>): Promise<TemplateAutoDTO> { 
    return ApiFetch({                             
        controller: `Templates`,                            
        controllerPath: `api/Templates`,            
        controllerMethod: `GetOne`,                              
        uriParams: `/${templateId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Templates_AddUpdate(t: TemplateAutoDTO, handlers?: ApiTSHandlersCallbacks<ResultSet<number>>): Promise<ResultSet<number>> { 
    return ApiFetch({                             
        controller: `Templates`,                            
        controllerPath: `api/Templates`,            
        controllerMethod: `AddUpdate`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: t,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Templates_Remove(id: number, handlers?: ApiTSHandlersCallbacks<ResultSet<number>>): Promise<ResultSet<number>> { 
    return ApiFetch({                             
        controller: `Templates`,                            
        controllerPath: `api/Templates`,            
        controllerMethod: `Remove`,                              
        uriParams: `?id=${id}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Templates_Clone(templateId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Templates`,                            
        controllerPath: `api/Templates`,            
        controllerMethod: `Clone`,                              
        uriParams: `/clone?templateId=${templateId}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function TemplatesGroups_Get( handlers?: ApiTSHandlersCallbacks<ItemGroupTemplate[]>): Promise<ItemGroupTemplate[]> { 
    return ApiFetch({                             
        controller: `TemplatesGroups`,                            
        controllerPath: `api/TemplatesGroups`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function TemplatesGroups_AssignTemplate(templateId: number, groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `TemplatesGroups`,                            
        controllerPath: `api/TemplatesGroups`,            
        controllerMethod: `AssignTemplate`,                              
        uriParams: `?templateId=${templateId}&groupId=${groupId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ItemGroupName_Set(groupId: number, groupName: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `ItemGroupName`,                            
        controllerPath: `api/ItemGroupName`,            
        controllerMethod: `Set`,                              
        uriParams: `?groupId=${groupId}&groupName=${encodeURIComponent(groupName)}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ItemGroups_Get(type: GroupType, handlers?: ApiTSHandlersCallbacks<ItemGroupUniversal[]>): Promise<ItemGroupUniversal[]> { 
    return ApiFetch({                             
        controller: `ItemGroups`,                            
        controllerPath: `api/ItemGroups`,            
        controllerMethod: `Get`,                              
        uriParams: `?type=${type}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ItemGroups_Add(groupName: string, parentId: number, type: GroupType, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `ItemGroups`,                            
        controllerPath: `api/ItemGroups`,            
        controllerMethod: `Add`,                              
        uriParams: `?groupName=${encodeURIComponent(groupName)}&parentId=${parentId ?? ""}&type=${type}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ItemGroups_SetParent(groupId: number, parentId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `ItemGroups`,                            
        controllerPath: `api/ItemGroups`,            
        controllerMethod: `SetParent`,                              
        uriParams: `/parent?groupId=${groupId}&parentId=${parentId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ItemGroups_Remove(groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `ItemGroups`,                            
        controllerPath: `api/ItemGroups`,            
        controllerMethod: `Remove`,                              
        uriParams: `?groupId=${groupId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceCommand_Send(deviceId: Guid, command: string, handlers?: ApiTSHandlersCallbacks<WsMessage<string>>): Promise<WsMessage<string>> { 
    return ApiFetch({                             
        controller: `DeviceCommand`,                            
        controllerPath: `api/DeviceCommand`,            
        controllerMethod: `Send`,                              
        uriParams: `?deviceId=${deviceId}&command=${encodeURIComponent(command)}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceContent_Set(deviceId: Guid[], templateId: number, broadcastId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `DeviceContent`,                            
        controllerPath: `api/DeviceContent`,            
        controllerMethod: `Set`,                              
        uriParams: `?templateId=${templateId ?? ""}&broadcastId=${broadcastId ?? ""}`,                             
        method: 'PUT',                                    
        params: deviceId,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceGroups_Add(groupName: string, parentId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `DeviceGroups`,                            
        controllerPath: `api/DeviceGroups`,            
        controllerMethod: `Add`,                              
        uriParams: `?groupName=${encodeURIComponent(groupName)}&parentId=${parentId ?? ""}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceGroups_Remove(groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `DeviceGroups`,                            
        controllerPath: `api/DeviceGroups`,            
        controllerMethod: `Remove`,                              
        uriParams: `?groupId=${groupId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceGroups_AssignDevice(deviceId: Guid, groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `DeviceGroups`,                            
        controllerPath: `api/DeviceGroups`,            
        controllerMethod: `AssignDevice`,                              
        uriParams: `?deviceId=${deviceId}&groupId=${groupId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceLastInfo_Get(deviceId: Guid, handlers?: ApiTSHandlersCallbacks<DeviceLastInfoDTO>): Promise<DeviceLastInfoDTO> { 
    return ApiFetch({                             
        controller: `DeviceLastInfo`,                            
        controllerPath: `api/DeviceLastInfo`,            
        controllerMethod: `Get`,                              
        uriParams: `?deviceId=${deviceId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceOfflineUpdate_Get(deviceId: Guid, handlers?: ApiTSHandlersCallbacks<Blob>): Promise<Blob> { 
    return ApiFetch({                             
        controller: `DeviceOfflineUpdate`,                            
        controllerPath: `api/DeviceOfflineUpdate`,            
        controllerMethod: `Get`,                              
        uriParams: `?deviceId=${deviceId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: true,
        handlers: handlers,                                        
    }); 
  }
  export function Devices_Get(search: string, groupId: number, skip: number, take: number, sortOrderType: DeviceSortOrderType, isSortDesc: boolean, status: number, handlers?: ApiTSHandlersCallbacks<DeviceAutoDTO[]>): Promise<DeviceAutoDTO[]> { 
    return ApiFetch({                             
        controller: `Devices`,                            
        controllerPath: `api/Devices`,            
        controllerMethod: `Get`,                              
        uriParams: `?search=${encodeURIComponent(search)}&groupId=${groupId ?? ""}&skip=${skip}&take=${take}&sortOrderType=${sortOrderType}&isSortDesc=${isSortDesc}&status=${status}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Devices_GetOne(deviceId: Guid, handlers?: ApiTSHandlersCallbacks<DeviceAutoDTO>): Promise<DeviceAutoDTO> { 
    return ApiFetch({                             
        controller: `Devices`,                            
        controllerPath: `api/Devices`,            
        controllerMethod: `GetOne`,                              
        uriParams: `/one?deviceId=${deviceId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Devices_Update(device: DeviceAutoDTO, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Devices`,                            
        controllerPath: `api/Devices`,            
        controllerMethod: `Update`,                              
        uriParams: ``,                             
        method: 'PUT',                                    
        params: device,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Devices_Remove(deviceId: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Devices`,                            
        controllerPath: `api/Devices`,            
        controllerMethod: `Remove`,                              
        uriParams: `?deviceId=${deviceId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DevicesPending_Get( handlers?: ApiTSHandlersCallbacks<DevicePendingDTO[]>): Promise<DevicePendingDTO[]> { 
    return ApiFetch({                             
        controller: `DevicesPending`,                            
        controllerPath: `api/DevicesPending`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DevicesPending_Add(code: string, isFixed: boolean, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `DevicesPending`,                            
        controllerPath: `api/DevicesPending`,            
        controllerMethod: `Add`,                              
        uriParams: `?code=${encodeURIComponent(code)}&isFixed=${isFixed}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DevicesStatusInfo_Get( handlers?: ApiTSHandlersCallbacks<DevicesStatusInfo>): Promise<DevicesStatusInfo> { 
    return ApiFetch({                             
        controller: `DevicesStatusInfo`,                            
        controllerPath: `api/DevicesStatusInfo`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PlaylistItems_Get(playlistId: Guid, handlers?: ApiTSHandlersCallbacks<PlaylistItemAutoDTO[]>): Promise<PlaylistItemAutoDTO[]> { 
    return ApiFetch({                             
        controller: `PlaylistItems`,                            
        controllerPath: `api/PlaylistItems`,            
        controllerMethod: `Get`,                              
        uriParams: `?playlistId=${playlistId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function PlaylistItems_Update(playlistId: Guid, items: PlaylistItemAutoDTO[], handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `PlaylistItems`,                            
        controllerPath: `api/PlaylistItems`,            
        controllerMethod: `Update`,                              
        uriParams: `?playlistId=${playlistId}`,                             
        method: 'PUT',                                    
        params: items,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Playlists_Get( handlers?: ApiTSHandlersCallbacks<PlaylistAutoDTO[]>): Promise<PlaylistAutoDTO[]> { 
    return ApiFetch({                             
        controller: `Playlists`,                            
        controllerPath: `api/Playlists`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Playlists_Add(name: string, description: string, handlers?: ApiTSHandlersCallbacks<PlaylistAutoDTO>): Promise<PlaylistAutoDTO> { 
    return ApiFetch({                             
        controller: `Playlists`,                            
        controllerPath: `api/Playlists`,            
        controllerMethod: `Add`,                              
        uriParams: `?name=${encodeURIComponent(name)}&description=${encodeURIComponent(description)}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Playlists_Update(playlistId: Guid, name: string, description: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Playlists`,                            
        controllerPath: `api/Playlists`,            
        controllerMethod: `Update`,                              
        uriParams: `?playlistId=${playlistId}&name=${encodeURIComponent(name)}&description=${encodeURIComponent(description)}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Playlists_Delete(playlistId: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Playlists`,                            
        controllerPath: `api/Playlists`,            
        controllerMethod: `Delete`,                              
        uriParams: `?playlistId=${playlistId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function MenuCategories_Get(menuId: Guid, handlers?: ApiTSHandlersCallbacks<MenuCategoryAutoDTO[]>): Promise<MenuCategoryAutoDTO[]> { 
    return ApiFetch({                             
        controller: `MenuCategories`,                            
        controllerPath: `api/MenuCategories`,            
        controllerMethod: `Get`,                              
        uriParams: `?menuId=${menuId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function MenuCategories_Update(menuId: Guid, categories: MenuCategoryAutoDTO[], handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `MenuCategories`,                            
        controllerPath: `api/MenuCategories`,            
        controllerMethod: `Update`,                              
        uriParams: `?menuId=${menuId}`,                             
        method: 'PUT',                                    
        params: categories,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Menus_Get( handlers?: ApiTSHandlersCallbacks<MenuAutoDTO[]>): Promise<MenuAutoDTO[]> { 
    return ApiFetch({                             
        controller: `Menus`,                            
        controllerPath: `api/Menus`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Menus_Add(name: string, currency: string, handlers?: ApiTSHandlersCallbacks<MenuAutoDTO>): Promise<MenuAutoDTO> { 
    return ApiFetch({                             
        controller: `Menus`,                            
        controllerPath: `api/Menus`,            
        controllerMethod: `Add`,                              
        uriParams: `?name=${encodeURIComponent(name)}&currency=${encodeURIComponent(currency)}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Menus_Update(id: Guid, name: string, currency: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Menus`,                            
        controllerPath: `api/Menus`,            
        controllerMethod: `Update`,                              
        uriParams: `?id=${id}&name=${encodeURIComponent(name)}&currency=${encodeURIComponent(currency)}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Menus_Delete(id: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Menus`,                            
        controllerPath: `api/Menus`,            
        controllerMethod: `Delete`,                              
        uriParams: `?id=${id}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFileDetails_Get(id: Guid, handlers?: ApiTSHandlersCallbacks<StorageFileDetails>): Promise<StorageFileDetails> { 
    return ApiFetch({                             
        controller: `StorageFileDetails`,                            
        controllerPath: `api/StorageFileDetails`,            
        controllerMethod: `Get`,                              
        uriParams: `?id=${id}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFileName_Set(id: Guid, name: string, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `StorageFileName`,                            
        controllerPath: `api/StorageFileName`,            
        controllerMethod: `Set`,                              
        uriParams: `?id=${id}&name=${encodeURIComponent(name)}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFiles_GetOne(id: Guid, handlers?: ApiTSHandlersCallbacks<AttachFileAutoDTO>): Promise<AttachFileAutoDTO> { 
    return ApiFetch({                             
        controller: `StorageFiles`,                            
        controllerPath: `api/StorageFiles`,            
        controllerMethod: `GetOne`,                              
        uriParams: `?id=${id}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFiles_Get(groupId: number, skip: number, take: number, filterSet: FilesFilterSet, handlers?: ApiTSHandlersCallbacks<AttachFileAutoDTO[]>): Promise<AttachFileAutoDTO[]> { 
    return ApiFetch({                             
        controller: `StorageFiles`,                            
        controllerPath: `api/StorageFiles`,            
        controllerMethod: `Get`,                              
        uriParams: `/get?groupId=${groupId ?? ""}&skip=${skip}&take=${take}`,                             
        method: 'POST',                                    
        params: filterSet,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFiles_Upload(file: File, groupId: number, replaceFileId: Guid, handlers?: ApiTSHandlersCallbacks<ResultSet<AttachFileAutoDTO>>): Promise<ResultSet<AttachFileAutoDTO>> { 
    return ApiFetch({                             
        controller: `StorageFiles`,                            
        controllerPath: `api/StorageFiles`,            
        controllerMethod: `Upload`,                              
        uriParams: `?file=${file}&groupId=${groupId ?? ""}&replaceFileId=${replaceFileId ?? ""}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'file', files: [file]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFiles_DownloadMass(ids: Guid[], handlers?: ApiTSHandlersCallbacks<Blob>): Promise<Blob> { 
    return ApiFetch({                             
        controller: `StorageFiles`,                            
        controllerPath: `api/StorageFiles`,            
        controllerMethod: `DownloadMass`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: ids,          
        files: [],      
        isReturnStream: true,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFiles_Delete(id: Guid, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `StorageFiles`,                            
        controllerPath: `api/StorageFiles`,            
        controllerMethod: `Delete`,                              
        uriParams: `?id=${id}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFilesGroups_Get( handlers?: ApiTSHandlersCallbacks<ItemGroupFile[]>): Promise<ItemGroupFile[]> { 
    return ApiFetch({                             
        controller: `StorageFilesGroups`,                            
        controllerPath: `api/StorageFilesGroups`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFilesGroups_AssignAttach(attachId: Guid, groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `StorageFilesGroups`,                            
        controllerPath: `api/StorageFilesGroups`,            
        controllerMethod: `AssignAttach`,                              
        uriParams: `?attachId=${attachId}&groupId=${groupId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StorageFileHash_Update( handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `StorageFileHash`,                            
        controllerPath: `api/StorageFileHash`,            
        controllerMethod: `Update`,                              
        uriParams: ``,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_Get(groupId: number, searchText: string, skip: number, take: number, handlers?: ApiTSHandlersCallbacks<BroadscastBlockDialy[]>): Promise<BroadscastBlockDialy[]> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `Get`,                              
        uriParams: `?groupId=${groupId ?? ""}&searchText=${encodeURIComponent(searchText)}&skip=${skip}&take=${take}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_GetOne(blockDailyId: number, handlers?: ApiTSHandlersCallbacks<BroadscastBlockDialy>): Promise<BroadscastBlockDialy> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `GetOne`,                              
        uriParams: `/${blockDailyId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_ShortGet(search: string, skip: number, take: number, handlers?: ApiTSHandlersCallbacks<BroadscastBlockShort[]>): Promise<BroadscastBlockShort[]> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `ShortGet`,                              
        uriParams: `/short?search=${encodeURIComponent(search)}&skip=${skip}&take=${take}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_AddUpdate(block: BroadscastBlockDialy, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `AddUpdate`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: block,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_AssignGroup(blockId: number, groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `AssignGroup`,                              
        uriParams: `?blockId=${blockId}&groupId=${groupId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_AssignToBroadcasts(blockId: number, broadcastIds: number[], handlers?: ApiTSHandlersCallbacks<AssignBlockToBroadcastResult[]>): Promise<AssignBlockToBroadcastResult[]> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `AssignToBroadcasts`,                              
        uriParams: `/assign-to-broadcasts?blockId=${blockId}`,                             
        method: 'POST',                                    
        params: broadcastIds,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_Clone(blockId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `Clone`,                              
        uriParams: `/clone?blockId=${blockId}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastDailyBlocks_Delete(dialyBlockId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `BroadcastDailyBlocks`,                            
        controllerPath: `api/BroadcastDailyBlocks`,            
        controllerMethod: `Delete`,                              
        uriParams: `?dialyBlockId=${dialyBlockId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastItems_Get(broadcastId: number, handlers?: ApiTSHandlersCallbacks<BroadcastItemAutoDTO[]>): Promise<BroadcastItemAutoDTO[]> { 
    return ApiFetch({                             
        controller: `BroadcastItems`,                            
        controllerPath: `api/BroadcastItems`,            
        controllerMethod: `Get`,                              
        uriParams: `?broadcastId=${broadcastId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_Get(groupId: number, searchText: string, skip: number, take: number, handlers?: ApiTSHandlersCallbacks<BroadcastAutoDTO[]>): Promise<BroadcastAutoDTO[]> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `Get`,                              
        uriParams: `?groupId=${groupId ?? ""}&searchText=${encodeURIComponent(searchText)}&skip=${skip}&take=${take}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_GetOne(broadcastId: number, handlers?: ApiTSHandlersCallbacks<BroadcastAutoDTO>): Promise<BroadcastAutoDTO> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `GetOne`,                              
        uriParams: `/${broadcastId}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_ShortGet(searchText: string, skip: number, take: number, handlers?: ApiTSHandlersCallbacks<IdNameDTO[]>): Promise<IdNameDTO[]> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `ShortGet`,                              
        uriParams: `/short?searchText=${encodeURIComponent(searchText)}&skip=${skip}&take=${take}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_Add(name: string, description: string, groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `Add`,                              
        uriParams: `?name=${encodeURIComponent(name)}&description=${encodeURIComponent(description)}&groupId=${groupId ?? ""}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_Update(broadcastId: number, name: string, description: string, changes: BroadcastItemChange[], handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `Update`,                              
        uriParams: `?broadcastId=${broadcastId}&name=${encodeURIComponent(name)}&description=${encodeURIComponent(description)}`,                             
        method: 'PUT',                                    
        params: changes,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_Clone(broadcastId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `Clone`,                              
        uriParams: `/clone?broadcastId=${broadcastId}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Broadcasts_Remove(broadcastId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Broadcasts`,                            
        controllerPath: `api/Broadcasts`,            
        controllerMethod: `Remove`,                              
        uriParams: `?broadcastId=${broadcastId}`,                             
        method: 'DELETE',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function BroadcastsGroup_Assign(broadcastId: number, groupId: number, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `BroadcastsGroup`,                            
        controllerPath: `api/BroadcastsGroup`,            
        controllerMethod: `Assign`,                              
        uriParams: `?broadcastId=${broadcastId}&groupId=${groupId ?? ""}`,                             
        method: 'PUT',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function SaServerSpaceFree_Get( handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `SaServerSpaceFree`,                            
        controllerPath: `api/SaServerSpaceFree`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function SaServerSpaceUsed_Get( handlers?: ApiTSHandlersCallbacks<Dict<number>>): Promise<Dict<number>> { 
    return ApiFetch({                             
        controller: `SaServerSpaceUsed`,                            
        controllerPath: `api/SaServerSpaceUsed`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function SaServerSpaceUsedFact_Get( handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `SaServerSpaceUsedFact`,                            
        controllerPath: `api/SaServerSpaceUsedFact`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function SaServerUsage_Get( handlers?: ApiTSHandlersCallbacks<ServerUsageData>): Promise<ServerUsageData> { 
    return ApiFetch({                             
        controller: `SaServerUsage`,                            
        controllerPath: `api/SaServerUsage`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function DeviceScreenshot_Send(uuid: Guid, file: File, handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `DeviceScreenshot`,                            
        controllerPath: `api/DeviceScreenshot`,            
        controllerMethod: `Send`,                              
        uriParams: `?uuid=${uuid}`,                             
        method: 'POST',                                    
        params: void 0,          
        files: [{parameterName: 'file', files: [file]}],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function ServerTime_Get( handlers?: ApiTSHandlersCallbacks<ServerTimeResponse>): Promise<ServerTimeResponse> { 
    return ApiFetch({                             
        controller: `ServerTime`,                            
        controllerPath: `api/ServerTime`,            
        controllerMethod: `Get`,                              
        uriParams: ``,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Statistics_Get(devices: Guid[], take: number, skip: number, dateStart: Date, dateFinish: Date, aggregationType: StatisticsAggregationType, handlers?: ApiTSHandlersCallbacks<StatisticGetDTO[]>): Promise<StatisticGetDTO[]> { 
    return ApiFetch({                             
        controller: `Statistics`,                            
        controllerPath: `api/Statistics`,            
        controllerMethod: `Get`,                              
        uriParams: `/items?take=${take}&skip=${skip}&dateStart=${dateToString(dateStart)}&dateFinish=${dateToString(dateFinish) ?? ""}&aggregationType=${aggregationType}`,                             
        method: 'POST',                                    
        params: devices,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Statistics_GetByDay(contentId: Guid, dateValue: Date, handlers?: ApiTSHandlersCallbacks<StatisticGetByDayDTO[]>): Promise<StatisticGetByDayDTO[]> { 
    return ApiFetch({                             
        controller: `Statistics`,                            
        controllerPath: `api/Statistics`,            
        controllerMethod: `GetByDay`,                              
        uriParams: `?contentId=${contentId}&dateValue=${dateToString(dateValue)}`,                             
        method: 'GET',                                    
        params: void 0,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function Statistics_Send(data: StatDataSendDto[], handlers?: ApiTSHandlersCallbacks<number>): Promise<number> { 
    return ApiFetch({                             
        controller: `Statistics`,                            
        controllerPath: `api/Statistics`,            
        controllerMethod: `Send`,                              
        uriParams: ``,                             
        method: 'POST',                                    
        params: data,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }
  export function StatisticsDeviceActivity_Get(devices: Guid[], take: number, skip: number, dateStart: Date, dateFinish: Date, aggregationType: StatisticsAggregationType, handlers?: ApiTSHandlersCallbacks<StatisticDeviceActivityGetDTO[]>): Promise<StatisticDeviceActivityGetDTO[]> { 
    return ApiFetch({                             
        controller: `StatisticsDeviceActivity`,                            
        controllerPath: `api/StatisticsDeviceActivity`,            
        controllerMethod: `Get`,                              
        uriParams: `/items?take=${take}&skip=${skip}&dateStart=${dateToString(dateStart)}&dateFinish=${dateToString(dateFinish) ?? ""}&aggregationType=${aggregationType}`,                             
        method: 'POST',                                    
        params: devices,          
        files: [],      
        isReturnStream: false,
        handlers: handlers,                                        
    }); 
  }

  export interface WsmUpdateStatus { 
    Action: string;
    StatusId: number;
    Data: WsmUpdateStatusData;
    CommandId?: Guid;
  } 

  export function GetWsmUpdateStatusEmpty(): WsmUpdateStatus  { 
    return {
      Action: "",
      StatusId: 0,
      Data: null,
      CommandId: null,
    };
  } 

  export interface WsmUpdateStatusData { 
    status: string;
    status_params: any;
    status_time: number;
  } 

  export function GetWsmUpdateStatusDataEmpty(): WsmUpdateStatusData  { 
    return {
      status: "",
      status_params: null,
      status_time: 0,
    };
  } 

  export interface WsmOnConnectInfo { 
    Action: string;
    StatusId: number;
    Data: WsmOnConnectInfoData;
    CommandId?: Guid;
  } 

  export function GetWsmOnConnectInfoEmpty(): WsmOnConnectInfo  { 
    return {
      Action: "",
      StatusId: 0,
      Data: null,
      CommandId: null,
    };
  } 

  export interface WsmOnConnectInfoData { 
    DeviceDateTime: Date;
    AppCoreVersion: string;
    AppVersion: string;
    OsVersion: string;
    WebViewVersion: string;
    ScreenResolution: string;
  } 

  export function GetWsmOnConnectInfoDataEmpty(): WsmOnConnectInfoData  { 
    return {
      DeviceDateTime: new Date(),
      AppCoreVersion: "",
      AppVersion: "",
      OsVersion: "",
      WebViewVersion: "",
      ScreenResolution: "",
    };
  } 

  export interface WsmContentConfiguration { 
    Action: string;
    StatusId: number;
    Data: WsmContentConfigurationData;
    CommandId?: Guid;
  } 

  export function GetWsmContentConfigurationEmpty(): WsmContentConfiguration  { 
    return {
      Action: "",
      StatusId: 0,
      Data: null,
      CommandId: null,
    };
  } 

  export interface WsmContentConfigurationData { 
    ApiKeys: Dict<string>;
    TemplateId?: number;
    BroadcastId?: number;
    TemplateData: DictN<TemplateAutoDTO>;
    BroadcastData: WsmBroadcastData[];
    Hash: string;
  } 

  export function GetWsmContentConfigurationDataEmpty(): WsmContentConfigurationData  { 
    return {
      ApiKeys: {},
      TemplateId: 0,
      BroadcastId: 0,
      TemplateData: {},
      BroadcastData: [],
      Hash: "",
    };
  } 

  export interface TemplateAutoDTO { 
    LoginName: string;
    Devices: Guid[];
    Id: number;
    Name: string;
    Description: string;
    ThumbnailBase64: string;
    LoginId: number;
    DateCreated: Date;
    DateUpdated: Date;
    DataJson: string;
    BgColor: string;
    BgImage: string;
    FontColor: string;
    RunningText: string;
    RunningTextSpeed?: number;
    GeoWeather: string;
    HasWeather?: boolean;
    HasHeadClock?: boolean;
    IsSoundEnabled?: boolean;
    ScreenResolution: string;
    ScreenRotation?: number;
    NetworkId: Guid;
    GroupId?: number;
    Language: string;
  } 

  export function GetTemplateAutoDTOEmpty(): TemplateAutoDTO  { 
    return {
      LoginName: "",
      Devices: [],
      Id: 0,
      Name: "",
      Description: "",
      ThumbnailBase64: "",
      LoginId: 0,
      DateCreated: new Date(),
      DateUpdated: new Date(),
      DataJson: "",
      BgColor: "",
      BgImage: "",
      FontColor: "",
      RunningText: "",
      RunningTextSpeed: 0,
      GeoWeather: "",
      HasWeather: false,
      HasHeadClock: false,
      IsSoundEnabled: false,
      ScreenResolution: "",
      ScreenRotation: 0,
      NetworkId: null,
      GroupId: 0,
      Language: "",
    };
  } 

  export interface WsmBroadcastData { 
    Order: number;
    DateStart: Date;
    DateFinish?: Date;
    TypeId: number;
    RepeatJson: string;
    GeoLocationJson: string;
    Contents: WsmBroadcastDataContent[];
  } 

  export function GetWsmBroadcastDataEmpty(): WsmBroadcastData  { 
    return {
      Order: 0,
      DateStart: new Date(),
      DateFinish: new Date(),
      TypeId: 0,
      RepeatJson: "",
      GeoLocationJson: "",
      Contents: [],
    };
  } 

  export interface WsmBroadcastDataContent { 
    TimeStartMinutes: number;
    TimeFinishMinutes: number;
    Templates: WsmBroadcastDataContentTemplate[];
  } 

  export function GetWsmBroadcastDataContentEmpty(): WsmBroadcastDataContent  { 
    return {
      TimeStartMinutes: 0,
      TimeFinishMinutes: 0,
      Templates: [],
    };
  } 

  export interface WsmBroadcastDataContentTemplate { 
    TemplateId: number;
    DurationSeconds: number;
    Order: number;
  } 

  export function GetWsmBroadcastDataContentTemplateEmpty(): WsmBroadcastDataContentTemplate  { 
    return {
      TemplateId: 0,
      DurationSeconds: 0,
      Order: 0,
    };
  } 

  export interface WsmDeviceSettings { 
    Action: string;
    StatusId: number;
    Data: WsmDeviceSettingsData;
    CommandId?: Guid;
  } 

  export function GetWsmDeviceSettingsEmpty(): WsmDeviceSettings  { 
    return {
      Action: "",
      StatusId: 0,
      Data: null,
      CommandId: null,
    };
  } 

  export interface WsmDeviceSettingsData { 
    TzOffset: number;
    SoundIsMuted: boolean;
    SoundVolume: number;
    Brightness: number;
    IsOledScreen: boolean;
    IsScreenLocked: boolean;
    IsOfflineModeEnabled: boolean;
    PosterBase64: string;
    VideoQuality: string;
  } 

  export function GetWsmDeviceSettingsDataEmpty(): WsmDeviceSettingsData  { 
    return {
      TzOffset: 0,
      SoundIsMuted: false,
      SoundVolume: 0,
      Brightness: 0,
      IsOledScreen: false,
      IsScreenLocked: false,
      IsOfflineModeEnabled: false,
      PosterBase64: "",
      VideoQuality: "",
    };
  } 

  export interface WsmUpdateKey { 
    Action: string;
    StatusId: number;
    Data: string;
    CommandId?: Guid;
  } 

  export function GetWsmUpdateKeyEmpty(): WsmUpdateKey  { 
    return {
      Action: "",
      StatusId: 0,
      Data: "",
      CommandId: null,
    };
  } 

  export interface WsMessage<TData> { 
    Action: string;
    StatusId: number;
    Data: TData;
    CommandId?: Guid;
  } 

  export function GetWsMessageEmpty<TData>(): WsMessage<TData>  { 
    return {
      Action: "",
      StatusId: 0,
      Data: null,
      CommandId: null,
    };
  } 

  export interface AdminWsMessage<TData> { 
    Action: string;
    Data: TData;
  } 

  export function GetAdminWsMessageEmpty<TData>(): AdminWsMessage<TData>  { 
    return {
      Action: "",
      Data: null,
    };
  } 

  export interface DeviceScreenshotUpdatedData { 
    DeviceId: Guid;
    UpdatedAt: Date;
  } 

  export function GetDeviceScreenshotUpdatedDataEmpty(): DeviceScreenshotUpdatedData  { 
    return {
      DeviceId: null,
      UpdatedAt: new Date(),
    };
  } 

  export interface AttachFileAutoDTO { 
    IsUsing: boolean;
    LoginName: string;
    Uid: Guid;
    FileName: string;
    FilePath: string;
    FileSize: number;
    DateCreated: Date;
    LoginId: number;
    TypeId: number;
    HlsPath: string;
    NetworkId: Guid;
    GroupId?: number;
    ContentLength?: number;
    Hash: string;
    QualityListJson: string;
  } 

  export function GetAttachFileAutoDTOEmpty(): AttachFileAutoDTO  { 
    return {
      IsUsing: false,
      LoginName: "",
      Uid: null,
      FileName: "",
      FilePath: "",
      FileSize: 0,
      DateCreated: new Date(),
      LoginId: 0,
      TypeId: 0,
      HlsPath: "",
      NetworkId: null,
      GroupId: 0,
      ContentLength: 0,
      Hash: "",
      QualityListJson: "",
    };
  } 

  export interface ResultSet<T> { 
    Error: number;
    ErrorText: string;
    Result: T;
  } 

  export function GetResultSetEmpty<T>(): ResultSet<T>  { 
    return {
      Error: 0,
      ErrorText: "",
      Result: null,
    };
  } 

  export interface NetworkLicenseDTO { 
    Id: number;
    NetworkId: Guid;
    Name: string;
    DateCreated: Date;
    DateStart: Date;
    DateExpired?: Date;
    StorageLimit: number;
    DeviceLimit: number;
    IsSumLimits: boolean;
    Roles: number[];
  } 

  export function GetNetworkLicenseDTOEmpty(): NetworkLicenseDTO  { 
    return {
      Id: 0,
      NetworkId: null,
      Name: "",
      DateCreated: new Date(),
      DateStart: new Date(),
      DateExpired: new Date(),
      StorageLimit: 0,
      DeviceLimit: 0,
      IsSumLimits: false,
      Roles: [],
    };
  } 

  export interface AuthenticateModel { 
    Login: string;
    Pass: string;
    IsRememberMe: boolean;
  } 

  export function GetAuthenticateModelEmpty(): AuthenticateModel  { 
    return {
      Login: "",
      Pass: "",
      IsRememberMe: false,
    };
  } 

  export interface AuthResultPack { 
    Error: string;
    RedirectUrl: string;
    AccessToken: string;
    RefreshToken: Guid;
    RefreshExpiresInSeconds: number;
  } 

  export function GetAuthResultPackEmpty(): AuthResultPack  { 
    return {
      Error: "",
      RedirectUrl: "",
      AccessToken: "",
      RefreshToken: null,
      RefreshExpiresInSeconds: 0,
    };
  } 

  export interface AuthPack { 
    AccessToken: string;
    RefreshToken: Guid;
    RefreshExpiresInSeconds: number;
  } 

  export function GetAuthPackEmpty(): AuthPack  { 
    return {
      AccessToken: "",
      RefreshToken: null,
      RefreshExpiresInSeconds: 0,
    };
  } 

  export interface NetworkDataDTO { 
    Id: Guid;
    Name: string;
    Users: NetworkUserDTO[];
    Licenses: NetworkLicenseDTO[];
  } 

  export function GetNetworkDataDTOEmpty(): NetworkDataDTO  { 
    return {
      Id: null,
      Name: "",
      Users: [],
      Licenses: [],
    };
  } 

  export interface NetworkUserDTO { 
    Id: number;
    Name: string;
    DateCreated: Date;
    Login: string;
    UserEmail: string;
    Roles: NetworkUserRoleDTO[];
  } 

  export function GetNetworkUserDTOEmpty(): NetworkUserDTO  { 
    return {
      Id: 0,
      Name: "",
      DateCreated: new Date(),
      Login: "",
      UserEmail: "",
      Roles: [],
    };
  } 

  export interface NetworkUserRoleDTO { 
    RoleId: number;
    IsRestricted: boolean;
  } 

  export function GetNetworkUserRoleDTOEmpty(): NetworkUserRoleDTO  { 
    return {
      RoleId: 0,
      IsRestricted: false,
    };
  } 

  export interface SummaryXlsxGenPack { 
    Caption: string;
    Lang: string;
    Pages: SummaryXlsxGenPage[];
  } 

  export function GetSummaryXlsxGenPackEmpty(): SummaryXlsxGenPack  { 
    return {
      Caption: "",
      Lang: "",
      Pages: [],
    };
  } 

  export interface SummaryXlsxGenPage { 
    Caption: string;
    HeadRowsMax: number;
    Tables: SummaryXlsxGenTable[];
  } 

  export function GetSummaryXlsxGenPageEmpty(): SummaryXlsxGenPage  { 
    return {
      Caption: "",
      HeadRowsMax: 0,
      Tables: [],
    };
  } 

  export interface SummaryXlsxGenTable { 
    Name: string;
    IsBordersForAll: boolean;
    Rows: SummaryXlsxGenRow[];
  } 

  export function GetSummaryXlsxGenTableEmpty(): SummaryXlsxGenTable  { 
    return {
      Name: "",
      IsBordersForAll: false,
      Rows: [],
    };
  } 

  export interface SummaryXlsxGenRow { 
    IsHead: boolean;
    Cells: SummaryXlsxGenCell[];
  } 

  export function GetSummaryXlsxGenRowEmpty(): SummaryXlsxGenRow  { 
    return {
      IsHead: false,
      Cells: [],
    };
  } 

  export interface SummaryXlsxGenCell { 
    ColSpan: number;
    RowSpan: number;
    Value: string;
    Styles: string;
  } 

  export function GetSummaryXlsxGenCellEmpty(): SummaryXlsxGenCell  { 
    return {
      ColSpan: 0,
      RowSpan: 0,
      Value: "",
      Styles: "",
    };
  } 

  export interface ContentSizeSet { 
    Q2160: number;
    Q1440: number;
    Q1080: number;
    Q720: number;
    Q480: number;
  } 

  export function GetContentSizeSetEmpty(): ContentSizeSet  { 
    return {
      Q2160: 0,
      Q1440: 0,
      Q1080: 0,
      Q720: 0,
      Q480: 0,
    };
  } 

  export interface ContentFilesSet { 
    AppCoreFiles: string[];
    ContentFiles: ContentFileItem[];
  } 

  export function GetContentFilesSetEmpty(): ContentFilesSet  { 
    return {
      AppCoreFiles: [],
      ContentFiles: [],
    };
  } 

  export interface ContentFileItem { 
    Hash: string;
    Path: string;
    Name: string;
  } 

  export function GetContentFileItemEmpty(): ContentFileItem  { 
    return {
      Hash: "",
      Path: "",
      Name: "",
    };
  } 

  export interface StartPack { 
    DateNow: Date;
    Roles: number[];
    StorageUsed: number;
    Network: NetworkDataDTO;
    NetworkName: string;
    UserId: number;
    UserName: string;
    ApiKeys: Dict<string>;
  } 

  export function GetStartPackEmpty(): StartPack  { 
    return {
      DateNow: new Date(),
      Roles: [],
      StorageUsed: 0,
      Network: null,
      NetworkName: "",
      UserId: 0,
      UserName: "",
      ApiKeys: {},
    };
  } 

  export interface NetworkUserCreateDTO { 
    Name: string;
    Login: string;
    Pwd: string;
    UserEmail: string;
    Roles: NetworkUserRoleDTO[];
  } 

  export function GetNetworkUserCreateDTOEmpty(): NetworkUserCreateDTO  { 
    return {
      Name: "",
      Login: "",
      Pwd: "",
      UserEmail: "",
      Roles: [],
    };
  } 

  export interface UserActionDTO { 
    Id: number;
    DateCreated: Date;
    User: string;
    ActionType: string;
    ActionSubType: string;
    MessageText1: string;
    MessageText2: string;
    Value1?: number;
    Value2?: number;
    ItemId?: number;
    ItemName: string;
  } 

  export function GetUserActionDTOEmpty(): UserActionDTO  { 
    return {
      Id: 0,
      DateCreated: new Date(),
      User: "",
      ActionType: "",
      ActionSubType: "",
      MessageText1: "",
      MessageText2: "",
      Value1: 0,
      Value2: 0,
      ItemId: 0,
      ItemName: "",
    };
  } 

  export interface RssFeedAutoDTO { 
    IsUsed: boolean;
    Items: RssFeedItemAutoDTO[];
    Id: Guid;
    LoginId: number;
    NetworkId: Guid;
    Link: string;
    RssTitle: string;
    RssLastUpdated: Date;
    LastFetched: Date;
    Name: string;
    ModerationType: number;
    PostLimit: number;
  } 

  export function GetRssFeedAutoDTOEmpty(): RssFeedAutoDTO  { 
    return {
      IsUsed: false,
      Items: [],
      Id: null,
      LoginId: 0,
      NetworkId: null,
      Link: "",
      RssTitle: "",
      RssLastUpdated: new Date(),
      LastFetched: new Date(),
      Name: "",
      ModerationType: 0,
      PostLimit: 0,
    };
  } 

  export interface RssFeedItemAutoDTO { 
    Id: number;
    RssFeedId: Guid;
    RssPostId: string;
    Author: string;
    Title: string;
    Description: string;
    Content: string;
    PublishingDate?: Date;
    Link: string;
    ImageUrl: string;
    IsModerated: boolean;
  } 

  export function GetRssFeedItemAutoDTOEmpty(): RssFeedItemAutoDTO  { 
    return {
      Id: 0,
      RssFeedId: null,
      RssPostId: "",
      Author: "",
      Title: "",
      Description: "",
      Content: "",
      PublishingDate: new Date(),
      Link: "",
      ImageUrl: "",
      IsModerated: false,
    };
  } 

  export interface RssFeedShort { 
    Id: Guid;
    Name: string;
  } 

  export function GetRssFeedShortEmpty(): RssFeedShort  { 
    return {
      Id: null,
      Name: "",
    };
  } 

  export enum RssModerationType {
    Pre = 1, //""
    Post = 2, //""
  }



  export interface PriceSetItemAutoDTO { 
    Id: number;
    PriceSetId: Guid;
    Name: string;
    Description: string;
    IdNumber: string;
    Barcode: string;
    PriceBase: number;
    PriceBaseSpecial?: number;
    PriceBeforeDiscount?: number;
    PriceOnDiscount?: number;
    DateDiscountStart?: Date;
    DateDiscountEnd?: Date;
  } 

  export function GetPriceSetItemAutoDTOEmpty(): PriceSetItemAutoDTO  { 
    return {
      Id: 0,
      PriceSetId: null,
      Name: "",
      Description: "",
      IdNumber: "",
      Barcode: "",
      PriceBase: 0,
      PriceBaseSpecial: 0,
      PriceBeforeDiscount: 0,
      PriceOnDiscount: 0,
      DateDiscountStart: new Date(),
      DateDiscountEnd: new Date(),
    };
  } 

  export interface PriceSetDto { 
    ItemCount: number;
    Id: Guid;
    Name: string;
    DateCreated: Date;
    NetworkId: Guid;
    PriceSetItems: PriceSetItem[];
  } 

  export function GetPriceSetDtoEmpty(): PriceSetDto  { 
    return {
      ItemCount: 0,
      Id: null,
      Name: "",
      DateCreated: new Date(),
      NetworkId: null,
      PriceSetItems: [],
    };
  } 

  export interface PriceSetItem { 
    Id: number;
    PriceSetId: Guid;
    Name: string;
    Description: string;
    IdNumber: string;
    Barcode: string;
    PriceBase: number;
    PriceBaseSpecial?: number;
    PriceBeforeDiscount?: number;
    PriceOnDiscount?: number;
    DateDiscountStart?: Date;
    DateDiscountEnd?: Date;
    PriceSet: PriceSet;
  } 

  export function GetPriceSetItemEmpty(): PriceSetItem  { 
    return {
      Id: 0,
      PriceSetId: null,
      Name: "",
      Description: "",
      IdNumber: "",
      Barcode: "",
      PriceBase: 0,
      PriceBaseSpecial: 0,
      PriceBeforeDiscount: 0,
      PriceOnDiscount: 0,
      DateDiscountStart: new Date(),
      DateDiscountEnd: new Date(),
      PriceSet: null,
    };
  } 

  export interface PriceSet { 
    Id: Guid;
    Name: string;
    DateCreated: Date;
    NetworkId: Guid;
    PriceSetItems: PriceSetItem[];
  } 

  export function GetPriceSetEmpty(): PriceSet  { 
    return {
      Id: null,
      Name: "",
      DateCreated: new Date(),
      NetworkId: null,
      PriceSetItems: [],
    };
  } 

  export enum TemplateSortOrderType {
    Name = 0, //"По названию"
    DateUpdated = 1, //"По дате изменения"
    CreatorLogin = 2, //"По имени создателя"
  }



  export interface TemplateShort { 
    Id: number;
    Name: string;
    ThumbnailBase64: string;
  } 

  export function GetTemplateShortEmpty(): TemplateShort  { 
    return {
      Id: 0,
      Name: "",
      ThumbnailBase64: "",
    };
  } 

  export interface ItemGroupTemplate { 
    UsedCount: number;
    Count: number;
    GroupId: number;
    ParentId?: number;
    GroupName: string;
    Groups: ItemGroupTemplate[];
  } 

  export function GetItemGroupTemplateEmpty(): ItemGroupTemplate  { 
    return {
      UsedCount: 0,
      Count: 0,
      GroupId: 0,
      ParentId: 0,
      GroupName: "",
      Groups: [],
    };
  } 

  export enum GroupType {
    Device = 1, //""
    Template = 3, //""
    AttachFile = 4, //""
    BroadcastBlock = 5, //""
    Broadcast = 6, //""
  }



  export interface ItemGroupUniversal { 
    GroupId: number;
    ParentId?: number;
    GroupName: string;
    Groups: ItemGroupUniversal[];
    ItemsActiveCount: number;
    ItemsCount: number;
    UsedStorage: number;
  } 

  export function GetItemGroupUniversalEmpty(): ItemGroupUniversal  { 
    return {
      GroupId: 0,
      ParentId: 0,
      GroupName: "",
      Groups: [],
      ItemsActiveCount: 0,
      ItemsCount: 0,
      UsedStorage: 0,
    };
  } 

  export interface DeviceLastInfoDTO { 
    DeviceId: Guid;
    LastConnected?: Date;
    LastSeen?: Date;
    StatusId: number;
    AppCoreVersion: string;
    AppVersion: string;
    DeviceDateTime?: Date;
    OsVersion: string;
    WebViewVersion: string;
    ScreenResolution: string;
  } 

  export function GetDeviceLastInfoDTOEmpty(): DeviceLastInfoDTO  { 
    return {
      DeviceId: null,
      LastConnected: new Date(),
      LastSeen: new Date(),
      StatusId: 0,
      AppCoreVersion: "",
      AppVersion: "",
      DeviceDateTime: new Date(),
      OsVersion: "",
      WebViewVersion: "",
      ScreenResolution: "",
    };
  } 

  export enum DeviceSortOrderType {
    Name = 0, //"По названию"
    Status = 1, //"По статусу"
    OnlineAmount = 2, //"По времени в сети"
    DateCreated = 3, //"По порядку создания"
  }



  export interface DeviceAutoDTO { 
    Info: DeviceLastInfoDTO;
    ContentName: string;
    Id: number;
    Uid: Guid;
    DateCreated: Date;
    LoginId?: number;
    Name: string;
    AppType: string;
    AppVersion: string;
    LicenseId?: number;
    BroadcastId?: number;
    TemplateId?: number;
    NetworkId: Guid;
    TimeZoneOffset: number;
    GroupId?: number;
    SoundVolume: number;
    SoundIsMuted?: boolean;
    Brightness: number;
    IsScreenLocked: boolean;
    IsOfflineModeEnabled: boolean;
    VideoQuality: string;
  } 

  export function GetDeviceAutoDTOEmpty(): DeviceAutoDTO  { 
    return {
      Info: null,
      ContentName: "",
      Id: 0,
      Uid: null,
      DateCreated: new Date(),
      LoginId: 0,
      Name: "",
      AppType: "",
      AppVersion: "",
      LicenseId: 0,
      BroadcastId: 0,
      TemplateId: 0,
      NetworkId: null,
      TimeZoneOffset: 0,
      GroupId: 0,
      SoundVolume: 0,
      SoundIsMuted: false,
      Brightness: 0,
      IsScreenLocked: false,
      IsOfflineModeEnabled: false,
      VideoQuality: "",
    };
  } 

  export interface DevicePendingDTO { 
    Code: string;
    IsFixed: boolean;
    DateCreated: Date;
  } 

  export function GetDevicePendingDTOEmpty(): DevicePendingDTO  { 
    return {
      Code: "",
      IsFixed: false,
      DateCreated: new Date(),
    };
  } 

  export interface DevicesStatusInfo { 
    Count: number;
    Online: number;
    Offline: number;
  } 

  export function GetDevicesStatusInfoEmpty(): DevicesStatusInfo  { 
    return {
      Count: 0,
      Online: 0,
      Offline: 0,
    };
  } 

  export interface PlaylistItemAutoDTO { 
    AttachFile: AttachFileAutoDTO;
    Id: number;
    PlaylistId: Guid;
    Duration: number;
    Order: number;
    TimeStartMinutes: number;
    TimeEndMinutes: number;
    WeekDaysJson: string;
    AttachFileId: Guid;
  } 

  export function GetPlaylistItemAutoDTOEmpty(): PlaylistItemAutoDTO  { 
    return {
      AttachFile: null,
      Id: 0,
      PlaylistId: null,
      Duration: 0,
      Order: 0,
      TimeStartMinutes: 0,
      TimeEndMinutes: 0,
      WeekDaysJson: "",
      AttachFileId: null,
    };
  } 

  export interface PlaylistAutoDTO { 
    Items: PlaylistItemAutoDTO[];
    Id: Guid;
    Name: string;
    Description: string;
    NetworkId: Guid;
    DateUpdated: Date;
    LoginId: number;
  } 

  export function GetPlaylistAutoDTOEmpty(): PlaylistAutoDTO  { 
    return {
      Items: [],
      Id: null,
      Name: "",
      Description: "",
      NetworkId: null,
      DateUpdated: new Date(),
      LoginId: 0,
    };
  } 

  export interface MenuCategoryAutoDTO { 
    Items: MenuItemAutoDTO[];
    Id: number;
    Name: string;
    MenuId: Guid;
    Order: number;
  } 

  export function GetMenuCategoryAutoDTOEmpty(): MenuCategoryAutoDTO  { 
    return {
      Items: [],
      Id: 0,
      Name: "",
      MenuId: null,
      Order: 0,
    };
  } 

  export interface MenuItemAutoDTO { 
    AttachFile: AttachFileAutoDTO;
    Id: number;
    Name: string;
    Description: string;
    MenuId: Guid;
    CategoryId?: number;
    Price: number;
    IsEnabled: boolean;
    Order: number;
    AttachFileId?: Guid;
  } 

  export function GetMenuItemAutoDTOEmpty(): MenuItemAutoDTO  { 
    return {
      AttachFile: null,
      Id: 0,
      Name: "",
      Description: "",
      MenuId: null,
      CategoryId: 0,
      Price: 0,
      IsEnabled: false,
      Order: 0,
      AttachFileId: null,
    };
  } 

  export interface MenuAutoDTO { 
    Categories: MenuCategoryAutoDTO[];
    Id: Guid;
    Name: string;
    NetworkId: Guid;
    DateUpdated: Date;
    Currency: string;
  } 

  export function GetMenuAutoDTOEmpty(): MenuAutoDTO  { 
    return {
      Categories: [],
      Id: null,
      Name: "",
      NetworkId: null,
      DateUpdated: new Date(),
      Currency: "",
    };
  } 

  export interface StorageFileDetails { 
    Templates: IdNameDTO[];
  } 

  export function GetStorageFileDetailsEmpty(): StorageFileDetails  { 
    return {
      Templates: [],
    };
  } 

  export interface IdNameDTO { 
    Id: number;
    Name: string;
  } 

  export function GetIdNameDTOEmpty(): IdNameDTO  { 
    return {
      Id: 0,
      Name: "",
    };
  } 

  export interface FilesFilterSet { 
    SearchText: string;
    AttachTypes: number[];
    StatusTypes: FilesStatusType[];
    SortType: FilesSortType;
    IsSortDesc: boolean;
    DateStart?: Date;
    DateFinish?: Date;
  } 

  export function GetFilesFilterSetEmpty(): FilesFilterSet  { 
    return {
      SearchText: "",
      AttachTypes: [],
      StatusTypes: [],
      SortType: FilesSortType.Name,
      IsSortDesc: false,
      DateStart: new Date(),
      DateFinish: new Date(),
    };
  } 

  export enum FilesStatusType {
    InUse = 1, //"Используется"
    NotInUse = 2, //"Не используется"
    Blocked = 3, //"Заблокирован"
  }



  export enum FilesSortType {
    Name = 1, //"Название"
    DateCreated = 2, //"Дата создания"
    Status = 3, //"Статус"
  }



  export interface ItemGroupFile { 
    UsedCount: number;
    Count: number;
    UsedStorage: number;
    GroupId: number;
    ParentId?: number;
    GroupName: string;
    Groups: ItemGroupFile[];
  } 

  export function GetItemGroupFileEmpty(): ItemGroupFile  { 
    return {
      UsedCount: 0,
      Count: 0,
      UsedStorage: 0,
      GroupId: 0,
      ParentId: 0,
      GroupName: "",
      Groups: [],
    };
  } 

  export interface BroadscastBlockDialy { 
    Id: number;
    Name: string;
    Description: string;
    Color: string;
    UsedCount: number;
    GroupId?: number;
    DateUpdated: Date;
    Contents: BroadscastBlockDialyContent[];
  } 

  export function GetBroadscastBlockDialyEmpty(): BroadscastBlockDialy  { 
    return {
      Id: 0,
      Name: "",
      Description: "",
      Color: "",
      UsedCount: 0,
      GroupId: 0,
      DateUpdated: new Date(),
      Contents: [],
    };
  } 

  export interface BroadscastBlockDialyContent { 
    Id: number;
    Caption: string;
    TimeStartMinutes: number;
    TimeFinishMinutes: number;
    Templates: BroadscastBlockDialyContentTemplate[];
  } 

  export function GetBroadscastBlockDialyContentEmpty(): BroadscastBlockDialyContent  { 
    return {
      Id: 0,
      Caption: "",
      TimeStartMinutes: 0,
      TimeFinishMinutes: 0,
      Templates: [],
    };
  } 

  export interface BroadscastBlockDialyContentTemplate { 
    Id: number;
    TemplateId: number;
    DurationSeconds: number;
    Order: number;
    IsEnabled: boolean;
  } 

  export function GetBroadscastBlockDialyContentTemplateEmpty(): BroadscastBlockDialyContentTemplate  { 
    return {
      Id: 0,
      TemplateId: 0,
      DurationSeconds: 0,
      Order: 0,
      IsEnabled: false,
    };
  } 

  export interface BroadscastBlockShort { 
    Id: number;
    Name: string;
    Color: string;
  } 

  export function GetBroadscastBlockShortEmpty(): BroadscastBlockShort  { 
    return {
      Id: 0,
      Name: "",
      Color: "",
    };
  } 

  export interface AssignBlockToBroadcastResult { 
    BroadcastId: number;
    BroadcastName: string;
    Success: boolean;
    Order: number;
    Error: string;
  } 

  export function GetAssignBlockToBroadcastResultEmpty(): AssignBlockToBroadcastResult  { 
    return {
      BroadcastId: 0,
      BroadcastName: "",
      Success: false,
      Order: 0,
      Error: "",
    };
  } 

  export interface BroadcastItemAutoDTO { 
    BlockColor: string;
    BlockName: string;
    Id: number;
    BroadcastId: number;
    BlockId: number;
    DateStart: Date;
    DateFinish?: Date;
    TypeId: number;
    Order: number;
    RepeatJson: string;
    GeoLocationJson: string;
  } 

  export function GetBroadcastItemAutoDTOEmpty(): BroadcastItemAutoDTO  { 
    return {
      BlockColor: "",
      BlockName: "",
      Id: 0,
      BroadcastId: 0,
      BlockId: 0,
      DateStart: new Date(),
      DateFinish: new Date(),
      TypeId: 0,
      Order: 0,
      RepeatJson: "",
      GeoLocationJson: "",
    };
  } 

  export interface BroadcastAutoDTO { 
    Devices: Guid[];
    Id: number;
    LoginId: number;
    NetworkId: Guid;
    Name: string;
    Description: string;
    DateCreated: Date;
    DateUpdated: Date;
    GroupId?: number;
  } 

  export function GetBroadcastAutoDTOEmpty(): BroadcastAutoDTO  { 
    return {
      Devices: [],
      Id: 0,
      LoginId: 0,
      NetworkId: null,
      Name: "",
      Description: "",
      DateCreated: new Date(),
      DateUpdated: new Date(),
      GroupId: 0,
    };
  } 

  export interface BroadcastItemChange { 
    Action: ActionType;
    Item: BroadcastItemAutoDTO;
  } 

  export function GetBroadcastItemChangeEmpty(): BroadcastItemChange  { 
    return {
      Action: ActionType.Add,
      Item: null,
    };
  } 

  export enum ActionType {
    Add = 0, //""
    Update = 1, //""
    Delete = 2, //""
  }



  export interface ServerUsageData { 
    DeviceCount: Dict<number>;
    StorageUsed: Dict<number>;
    ServerUsedSpace: number;
    ServerFreeSpace: number;
  } 

  export function GetServerUsageDataEmpty(): ServerUsageData  { 
    return {
      DeviceCount: {},
      StorageUsed: {},
      ServerUsedSpace: 0,
      ServerFreeSpace: 0,
    };
  } 

  export interface ServerTimeResponse { 
    TimeMs: number;
  } 

  export function GetServerTimeResponseEmpty(): ServerTimeResponse  { 
    return {
      TimeMs: 0,
    };
  } 

  export enum StatisticsAggregationType {
    Hour = 0, //""
    Day = 1, //""
    Week = 2, //""
    Month = 3, //""
  }



  export interface StatisticGetDTO { 
    Id: number;
    DateValue: Date;
    DeviceId: Guid;
    DeviceName: string;
    TemplateId: number;
    AttachId?: Guid;
    AttachName: string;
    Content: string;
    ShowCount: number;
    ShowDuration: number;
  } 

  export function GetStatisticGetDTOEmpty(): StatisticGetDTO  { 
    return {
      Id: 0,
      DateValue: new Date(),
      DeviceId: null,
      DeviceName: "",
      TemplateId: 0,
      AttachId: null,
      AttachName: "",
      Content: "",
      ShowCount: 0,
      ShowDuration: 0,
    };
  } 

  export interface StatisticGetByDayDTO { 
    TimeMinuteStart: number;
    ShowCount: number;
    ShowDuration: number;
  } 

  export function GetStatisticGetByDayDTOEmpty(): StatisticGetByDayDTO  { 
    return {
      TimeMinuteStart: 0,
      ShowCount: 0,
      ShowDuration: 0,
    };
  } 

  export interface StatDataSendDto { 
    DeviceId: Guid;
    DeviceDateTime: Date;
    TemplateId: number;
    WidgetType: string;
    ContentId: string;
    ShowCount: number;
    ShowDuration: number;
  } 

  export function GetStatDataSendDtoEmpty(): StatDataSendDto  { 
    return {
      DeviceId: null,
      DeviceDateTime: new Date(),
      TemplateId: 0,
      WidgetType: "",
      ContentId: "",
      ShowCount: 0,
      ShowDuration: 0,
    };
  } 

  export interface StatisticDeviceActivityGetDTO { 
    Id: number;
    DateCreated: Date;
    DeviceId: Guid;
    DeviceName: string;
    StatCount: number;
  } 

  export function GetStatisticDeviceActivityGetDTOEmpty(): StatisticDeviceActivityGetDTO  { 
    return {
      Id: 0,
      DateCreated: new Date(),
      DeviceId: null,
      DeviceName: "",
      StatCount: 0,
    };
  } 


  export namespace Enums {
    export enum ActionsFromClient {
      OnConnectInfo = "on_connect_data", //"OnConnectInfo", "OnConnectInfo"
      CommandResult = "command_result", //"CommandResult", "CommandResult"
    }

    export enum ActionsToClient {
      ContentConfigurationGet = "content_configuration_get", //"ContentConfigurationGet", "ContentConfigurationGet"
      ContentConfigurationSet = "content_configuration_set", //"ContentConfigurationSet", "ContentConfigurationSet"
      MakeScreenshot = "make_screenshot", //"MakeScreenshot", "MakeScreenshot"
      RestartApplication = "restart_application", //"RestartApplication", "RestartApplication"
      RestartDevice = "restart_device", //"RestartDevice", "RestartDevice"
      CacheClear = "cache_clear", //"CacheClear", "CacheClear"
      GetDeviceLog = "get_device_log", //"GetDeviceLog", "GetDeviceLog"
      ClientOverridden = "client_overridden", //"ClientOverridden", "ClientOverridden"
      DeviceSettingsGet = "device_settings_get", //"DeviceSettingsGet", "DeviceSettingsGet"
      DeviceSettingsSet = "device_settings_set", //"DeviceSettingsSet", "DeviceSettingsSet"
      DeviceKeyGet = "device_key_get", //"DeviceKeyGet", "DeviceKeyGet"
      DeviceKeySet = "device_key_set", //"DeviceKeySet", "DeviceKeySet"
      NetworkSetupRun = "network_setup_run", //"NetworkSetupRun", "NetworkSetupRun"
    }

    export enum ActionsToAdmin {
      DeviceStatusChanged = "device_status_changed", //"DeviceStatusChanged", "DeviceStatusChanged"
      DeviceScreenshotUpdated = "device_screenshot_updated", //"DeviceScreenshotUpdated", "DeviceScreenshotUpdated"
      DeviceNewConnected = "device_new_connected", //"DeviceNewConnected", "DeviceNewConnected"
    }

    export enum RoleVirtual {
      Anonymous = 10000, //"anonymous", "anonymous"
    }

    export enum ActionType {
      Add = 0, //"Add", "Add"
      Update = 1, //"Update", "Update"
      Delete = 2, //"Delete", "Delete"
    }

    export enum ApiKeyType {
      OpenWeatherApiKey = "OpenWeatherApiKey", //"OpenWeatherApiKey", "OpenWeatherApiKey"
      YandexMapApiKey = "YandexMapApiKey", //"YandexMapApiKey", "YandexMapApiKey"
    }

    export enum BroadcastItemType {
      Empty = 0, //"Empty", "Empty"
      Const = 1, //"Постоянный", "Постоянный"
      Repeat = 2, //"Повторяющийся", "Повторяющийся"
      Click = 3, //"По клику", "По клику"
      Geo = 4, //"По геолокации", "По геолокации"
    }

    export enum DeviceStatusType {
      Online = 1, //"В сети", "В сети"
      Offline = 2, //"Не в сети", "Не в сети"
    }

    export enum GroupType {
      Device = 1, //"Device", "Device"
      Template = 3, //"Template", "Template"
      AttachFile = 4, //"AttachFile", "AttachFile"
      BroadcastBlock = 5, //"BroadcastBlock", "BroadcastBlock"
      Broadcast = 6, //"Broadcast", "Broadcast"
    }

    export enum RssModerationType {
      Pre = 1, //"Премодерация", "Премодерация"
      Post = 2, //"Постмодерация", "Постмодерация"
    }

    export enum VirtualRole {
      Anonymous = 10000, //"anonymous", 
      HasAtLeastOneAccountingUnit = 20001, //"NoAccountingUnits", 
      HasAtLeastOneUnit = 20002, //"NoUnits", 
      HasAtLeastOneOwner = 20003, //"NoOwners", 
    }

    export enum DeviceSortOrderType {
      Name = 0, //"По названию", 
      Status = 1, //"По статусу", 
      OnlineAmount = 2, //"По времени в сети", 
      DateCreated = 3, //"По порядку создания", 
    }

    export enum TemplateSortOrderType {
      Name = 0, //"По названию", 
      DateUpdated = 1, //"По дате изменения", 
      CreatorLogin = 2, //"По имени создателя", 
    }

    export enum FilesSortType {
      Name = 1, //"Название", 
      DateCreated = 2, //"Дата создания", 
      Status = 3, //"Статус", 
    }

    export enum FilesStatusType {
      InUse = 1, //"Используется", 
      NotInUse = 2, //"Не используется", 
      Blocked = 3, //"Заблокирован", 
    }

    export enum StatisticsAggregationType {
      Hour = 0, //"Hour", "Hour"
      Day = 1, //"Day", "Day"
      Week = 2, //"Week", "Week"
      Month = 3, //"Month", "Month"
    }

    export enum AttachType {
      Image = 1, //"Изображение", "Изображение"
      Video = 2, //"Видео", "Видео"
      Pdf = 3, //"Pdf", "Pdf"
      Pptx = 4, //"Презентация (pptx)", "Презентация (pptx)"
      Other = 100, //"Прочее", "Прочее"
    }

    export enum Role {
      SA = -1, //"SA", "SA"
      Any = 0, //"Any", "Any"
      Admin = 1, //"Администратор", "Администратор"
      NetworkAdmin = 99, //"Администратор сети", "Администратор сети"
      Device = 100, //"Устройства. Чтение", "Устройства. Чтение"
      DeviceManagement = 101, //"Устройства. Управление", "Устройства. Управление"
      DeviceContentChange = 102, //"Устройства. Назначение контента", "Устройства. Назначение контента"
      DeviceCommand = 103, //"Устройства. Отправка команд", "Устройства. Отправка команд"
      Templates = 200, //"Шаблоны. Чтение", "Шаблоны. Чтение"
      TemplatesManagement = 201, //"Шаблоны. Управление", "Шаблоны. Управление"
      TemplatesWidgetBasic = 211, //"Виджеты базовые", "Виджеты базовые"
      TemplatesWidgetPremium = 212, //"Виджеты премиум", "Виджеты премиум"
      Broadcast = 300, //"Эфиры. Чтение", "Эфиры. Чтение"
      BroadcastAddEdit = 301, //"Эфиры. Управление", "Эфиры. Управление"
      StorageMediaReplaceDelete = 401, //"Файлы. Замена и удаление", "Файлы. Замена и удаление"
      SettingsUsers = 500, //"Пользователи. Чтение", "Пользователи. Чтение"
      SettingsUsersManagement = 501, //"Пользователи. Управление", "Пользователи. Управление"
      SettingsDevicePosterChange = 510, //"Сеть. Изменение постера устройств", "Сеть. Изменение постера устройств"
      AdsSetup = 600, //"Реклама. Чтение", "Реклама. Чтение"
      AdsSetupManagement = 601, //"Реклама. Управление", "Реклама. Управление"
      TemplatesLibrary = 700, //"Библиотека шаблонов", "Библиотека шаблонов"
      VideoWall = 800, //"Видеостена. Чтение", "Видеостена. Чтение"
      VideoWallManagement = 801, //"Видеостена. Управление", "Видеостена. Управление"
      VideoAnalysis = 900, //"Видеоаналитика", "Видеоаналитика"
      AiGenerations = 1000, //"Генерация AI-текстов и изображений", "Генерация AI-текстов и изображений"
    }

  };

  export const EnumDict = {
    ActionsFromClient: {
      "on_connect_data": "OnConnectInfo",
      "command_result": "CommandResult",
    },

    ActionsToClient: {
      "content_configuration_get": "ContentConfigurationGet",
      "content_configuration_set": "ContentConfigurationSet",
      "make_screenshot": "MakeScreenshot",
      "restart_application": "RestartApplication",
      "restart_device": "RestartDevice",
      "cache_clear": "CacheClear",
      "get_device_log": "GetDeviceLog",
      "client_overridden": "ClientOverridden",
      "device_settings_get": "DeviceSettingsGet",
      "device_settings_set": "DeviceSettingsSet",
      "device_key_get": "DeviceKeyGet",
      "device_key_set": "DeviceKeySet",
      "network_setup_run": "NetworkSetupRun",
    },

    ActionsToAdmin: {
      "device_status_changed": "DeviceStatusChanged",
      "device_screenshot_updated": "DeviceScreenshotUpdated",
      "device_new_connected": "DeviceNewConnected",
    },

    RoleVirtual: {
      10000: "anonymous",
    },

    ActionType: {
      0: "Add",
      1: "Update",
      2: "Delete",
    },

    ApiKeyType: {
      "OpenWeatherApiKey": "OpenWeatherApiKey",
      "YandexMapApiKey": "YandexMapApiKey",
    },

    BroadcastItemType: {
      0: "Empty",
      1: "Постоянный",
      2: "Повторяющийся",
      3: "По клику",
      4: "По геолокации",
    },

    DeviceStatusType: {
      1: "В сети",
      2: "Не в сети",
    },

    GroupType: {
      1: "Device",
      3: "Template",
      4: "AttachFile",
      5: "BroadcastBlock",
      6: "Broadcast",
    },

    RssModerationType: {
      1: "Премодерация",
      2: "Постмодерация",
    },

    VirtualRole: {
      10000: "anonymous",
      20001: "NoAccountingUnits",
      20002: "NoUnits",
      20003: "NoOwners",
    },

    DeviceSortOrderType: {
      0: "По названию",
      1: "По статусу",
      2: "По времени в сети",
      3: "По порядку создания",
    },

    TemplateSortOrderType: {
      0: "По названию",
      1: "По дате изменения",
      2: "По имени создателя",
    },

    FilesSortType: {
      1: "Название",
      2: "Дата создания",
      3: "Статус",
    },

    FilesStatusType: {
      1: "Используется",
      2: "Не используется",
      3: "Заблокирован",
    },

    StatisticsAggregationType: {
      0: "Hour",
      1: "Day",
      2: "Week",
      3: "Month",
    },

    AttachType: {
      1: "Изображение",
      2: "Видео",
      3: "Pdf",
      4: "Презентация (pptx)",
      100: "Прочее",
    },

    Role: {
      [-1]: "SA",
      0: "Any",
      1: "Администратор",
      99: "Администратор сети",
      100: "Устройства. Чтение",
      101: "Устройства. Управление",
      102: "Устройства. Назначение контента",
      103: "Устройства. Отправка команд",
      200: "Шаблоны. Чтение",
      201: "Шаблоны. Управление",
      211: "Виджеты базовые",
      212: "Виджеты премиум",
      300: "Эфиры. Чтение",
      301: "Эфиры. Управление",
      401: "Файлы. Замена и удаление",
      500: "Пользователи. Чтение",
      501: "Пользователи. Управление",
      510: "Сеть. Изменение постера устройств",
      600: "Реклама. Чтение",
      601: "Реклама. Управление",
      700: "Библиотека шаблонов",
      800: "Видеостена. Чтение",
      801: "Видеостена. Управление",
      900: "Видеоаналитика",
      1000: "Генерация AI-текстов и изображений",
    },

  };

  export const EnumLists = {
    ActionsFromClients: [
      {ID: "on_connect_data", Value: "on_connect_data", Name: "OnConnectInfo"},
      {ID: "command_result", Value: "command_result", Name: "CommandResult"},
    ],

    ActionsToClients: [
      {ID: "content_configuration_get", Value: "content_configuration_get", Name: "ContentConfigurationGet"},
      {ID: "content_configuration_set", Value: "content_configuration_set", Name: "ContentConfigurationSet"},
      {ID: "make_screenshot", Value: "make_screenshot", Name: "MakeScreenshot"},
      {ID: "restart_application", Value: "restart_application", Name: "RestartApplication"},
      {ID: "restart_device", Value: "restart_device", Name: "RestartDevice"},
      {ID: "cache_clear", Value: "cache_clear", Name: "CacheClear"},
      {ID: "get_device_log", Value: "get_device_log", Name: "GetDeviceLog"},
      {ID: "client_overridden", Value: "client_overridden", Name: "ClientOverridden"},
      {ID: "device_settings_get", Value: "device_settings_get", Name: "DeviceSettingsGet"},
      {ID: "device_settings_set", Value: "device_settings_set", Name: "DeviceSettingsSet"},
      {ID: "device_key_get", Value: "device_key_get", Name: "DeviceKeyGet"},
      {ID: "device_key_set", Value: "device_key_set", Name: "DeviceKeySet"},
      {ID: "network_setup_run", Value: "network_setup_run", Name: "NetworkSetupRun"},
    ],

    ActionsToAdmins: [
      {ID: "device_status_changed", Value: "device_status_changed", Name: "DeviceStatusChanged"},
      {ID: "device_screenshot_updated", Value: "device_screenshot_updated", Name: "DeviceScreenshotUpdated"},
      {ID: "device_new_connected", Value: "device_new_connected", Name: "DeviceNewConnected"},
    ],

    RoleVirtuals: [
      {ID: 10000, Value: 10000, Name: "anonymous"},
    ],

    ActionTypes: [
      {ID: 0, Value: 0, Name: "Add"},
      {ID: 1, Value: 1, Name: "Update"},
      {ID: 2, Value: 2, Name: "Delete"},
    ],

    ApiKeyTypes: [
      {ID: "OpenWeatherApiKey", Value: "OpenWeatherApiKey", Name: "OpenWeatherApiKey"},
      {ID: "YandexMapApiKey", Value: "YandexMapApiKey", Name: "YandexMapApiKey"},
    ],

    BroadcastItemTypes: [
      {ID: 0, Value: 0, Name: "Empty"},
      {ID: 1, Value: 1, Name: "Постоянный"},
      {ID: 2, Value: 2, Name: "Повторяющийся"},
      {ID: 3, Value: 3, Name: "По клику"},
      {ID: 4, Value: 4, Name: "По геолокации"},
    ],

    DeviceStatusTypes: [
      {ID: 1, Value: 1, Name: "В сети"},
      {ID: 2, Value: 2, Name: "Не в сети"},
    ],

    GroupTypes: [
      {ID: 1, Value: 1, Name: "Device"},
      {ID: 3, Value: 3, Name: "Template"},
      {ID: 4, Value: 4, Name: "AttachFile"},
      {ID: 5, Value: 5, Name: "BroadcastBlock"},
      {ID: 6, Value: 6, Name: "Broadcast"},
    ],

    RssModerationTypes: [
      {ID: 1, Value: 1, Name: "Премодерация"},
      {ID: 2, Value: 2, Name: "Постмодерация"},
    ],

    VirtualRoles: [
      {ID: 10000, Value: 10000, Name: "anonymous"},
      {ID: 20001, Value: 20001, Name: "NoAccountingUnits"},
      {ID: 20002, Value: 20002, Name: "NoUnits"},
      {ID: 20003, Value: 20003, Name: "NoOwners"},
    ],

    DeviceSortOrderTypes: [
      {ID: 0, Value: 0, Name: "По названию"},
      {ID: 1, Value: 1, Name: "По статусу"},
      {ID: 2, Value: 2, Name: "По времени в сети"},
      {ID: 3, Value: 3, Name: "По порядку создания"},
    ],

    TemplateSortOrderTypes: [
      {ID: 0, Value: 0, Name: "По названию"},
      {ID: 1, Value: 1, Name: "По дате изменения"},
      {ID: 2, Value: 2, Name: "По имени создателя"},
    ],

    FilesSortTypes: [
      {ID: 1, Value: 1, Name: "Название"},
      {ID: 2, Value: 2, Name: "Дата создания"},
      {ID: 3, Value: 3, Name: "Статус"},
    ],

    FilesStatusTypes: [
      {ID: 1, Value: 1, Name: "Используется"},
      {ID: 2, Value: 2, Name: "Не используется"},
      {ID: 3, Value: 3, Name: "Заблокирован"},
    ],

    StatisticsAggregationTypes: [
      {ID: 0, Value: 0, Name: "Hour"},
      {ID: 1, Value: 1, Name: "Day"},
      {ID: 2, Value: 2, Name: "Week"},
      {ID: 3, Value: 3, Name: "Month"},
    ],

    AttachTypes: [
      {ID: 1, Value: 1, Name: "Изображение"},
      {ID: 2, Value: 2, Name: "Видео"},
      {ID: 3, Value: 3, Name: "Pdf"},
      {ID: 4, Value: 4, Name: "Презентация (pptx)"},
      {ID: 100, Value: 100, Name: "Прочее"},
    ],

    Roles: [
      {ID: -1, Value: -1, Name: "SA"},
      {ID: 0, Value: 0, Name: "Any"},
      {ID: 1, Value: 1, Name: "Администратор"},
      {ID: 99, Value: 99, Name: "Администратор сети"},
      {ID: 100, Value: 100, Name: "Устройства. Чтение"},
      {ID: 101, Value: 101, Name: "Устройства. Управление"},
      {ID: 102, Value: 102, Name: "Устройства. Назначение контента"},
      {ID: 103, Value: 103, Name: "Устройства. Отправка команд"},
      {ID: 200, Value: 200, Name: "Шаблоны. Чтение"},
      {ID: 201, Value: 201, Name: "Шаблоны. Управление"},
      {ID: 211, Value: 211, Name: "Виджеты базовые"},
      {ID: 212, Value: 212, Name: "Виджеты премиум"},
      {ID: 300, Value: 300, Name: "Эфиры. Чтение"},
      {ID: 301, Value: 301, Name: "Эфиры. Управление"},
      {ID: 401, Value: 401, Name: "Файлы. Замена и удаление"},
      {ID: 500, Value: 500, Name: "Пользователи. Чтение"},
      {ID: 501, Value: 501, Name: "Пользователи. Управление"},
      {ID: 510, Value: 510, Name: "Сеть. Изменение постера устройств"},
      {ID: 600, Value: 600, Name: "Реклама. Чтение"},
      {ID: 601, Value: 601, Name: "Реклама. Управление"},
      {ID: 700, Value: 700, Name: "Библиотека шаблонов"},
      {ID: 800, Value: 800, Name: "Видеостена. Чтение"},
      {ID: 801, Value: 801, Name: "Видеостена. Управление"},
      {ID: 900, Value: 900, Name: "Видеоаналитика"},
      {ID: 1000, Value: 1000, Name: "Генерация AI-текстов и изображений"},
    ],

  };


  export const Static = {
    UserPhotoDefault: "doc/UserPhotos/user-photo-default.svg", 
    VideoQuality: ["480p","720p","1080p","1440p","2160p","original_legacy"], 
    AttachSizePool: [50,150,300], 
  };

}
delete Date.prototype.toJSON;
console.warn(`[api.ts] Deleted Date.prototype.toJSON`);
export default WebApi;
export type WsmUpdateStatus = WebApi.WsmUpdateStatus;
export type WsmUpdateStatusData = WebApi.WsmUpdateStatusData;
export type WsmOnConnectInfo = WebApi.WsmOnConnectInfo;
export type WsmOnConnectInfoData = WebApi.WsmOnConnectInfoData;
export type WsmContentConfiguration = WebApi.WsmContentConfiguration;
export type WsmContentConfigurationData = WebApi.WsmContentConfigurationData;
export type TemplateAutoDTO = WebApi.TemplateAutoDTO;
export type WsmBroadcastData = WebApi.WsmBroadcastData;
export type WsmBroadcastDataContent = WebApi.WsmBroadcastDataContent;
export type WsmBroadcastDataContentTemplate = WebApi.WsmBroadcastDataContentTemplate;
export type WsmDeviceSettings = WebApi.WsmDeviceSettings;
export type WsmDeviceSettingsData = WebApi.WsmDeviceSettingsData;
export type WsmUpdateKey = WebApi.WsmUpdateKey;
export type WsMessage<TData> = WebApi.WsMessage<TData>;
export type AdminWsMessage<TData> = WebApi.AdminWsMessage<TData>;
export type DeviceScreenshotUpdatedData = WebApi.DeviceScreenshotUpdatedData;
export type AttachFileAutoDTO = WebApi.AttachFileAutoDTO;
export type ResultSet<T> = WebApi.ResultSet<T>;
export type NetworkLicenseDTO = WebApi.NetworkLicenseDTO;
export type AuthenticateModel = WebApi.AuthenticateModel;
export type AuthResultPack = WebApi.AuthResultPack;
export type AuthPack = WebApi.AuthPack;
export type NetworkDataDTO = WebApi.NetworkDataDTO;
export type NetworkUserDTO = WebApi.NetworkUserDTO;
export type NetworkUserRoleDTO = WebApi.NetworkUserRoleDTO;
export type SummaryXlsxGenPack = WebApi.SummaryXlsxGenPack;
export type SummaryXlsxGenPage = WebApi.SummaryXlsxGenPage;
export type SummaryXlsxGenTable = WebApi.SummaryXlsxGenTable;
export type SummaryXlsxGenRow = WebApi.SummaryXlsxGenRow;
export type SummaryXlsxGenCell = WebApi.SummaryXlsxGenCell;
export type ContentSizeSet = WebApi.ContentSizeSet;
export type ContentFilesSet = WebApi.ContentFilesSet;
export type ContentFileItem = WebApi.ContentFileItem;
export type StartPack = WebApi.StartPack;
export type NetworkUserCreateDTO = WebApi.NetworkUserCreateDTO;
export type UserActionDTO = WebApi.UserActionDTO;
export type RssFeedAutoDTO = WebApi.RssFeedAutoDTO;
export type RssFeedItemAutoDTO = WebApi.RssFeedItemAutoDTO;
export type RssFeedShort = WebApi.RssFeedShort;
export type RssModerationType = WebApi.RssModerationType;
export type PriceSetItemAutoDTO = WebApi.PriceSetItemAutoDTO;
export type PriceSetDto = WebApi.PriceSetDto;
export type PriceSetItem = WebApi.PriceSetItem;
export type PriceSet = WebApi.PriceSet;
export type TemplateSortOrderType = WebApi.TemplateSortOrderType;
export type TemplateShort = WebApi.TemplateShort;
export type ItemGroupTemplate = WebApi.ItemGroupTemplate;
export type GroupType = WebApi.GroupType;
export type ItemGroupUniversal = WebApi.ItemGroupUniversal;
export type DeviceLastInfoDTO = WebApi.DeviceLastInfoDTO;
export type DeviceSortOrderType = WebApi.DeviceSortOrderType;
export type DeviceAutoDTO = WebApi.DeviceAutoDTO;
export type DevicePendingDTO = WebApi.DevicePendingDTO;
export type DevicesStatusInfo = WebApi.DevicesStatusInfo;
export type PlaylistItemAutoDTO = WebApi.PlaylistItemAutoDTO;
export type PlaylistAutoDTO = WebApi.PlaylistAutoDTO;
export type MenuCategoryAutoDTO = WebApi.MenuCategoryAutoDTO;
export type MenuItemAutoDTO = WebApi.MenuItemAutoDTO;
export type MenuAutoDTO = WebApi.MenuAutoDTO;
export type StorageFileDetails = WebApi.StorageFileDetails;
export type IdNameDTO = WebApi.IdNameDTO;
export type FilesFilterSet = WebApi.FilesFilterSet;
export type FilesStatusType = WebApi.FilesStatusType;
export type FilesSortType = WebApi.FilesSortType;
export type ItemGroupFile = WebApi.ItemGroupFile;
export type BroadscastBlockDialy = WebApi.BroadscastBlockDialy;
export type BroadscastBlockDialyContent = WebApi.BroadscastBlockDialyContent;
export type BroadscastBlockDialyContentTemplate = WebApi.BroadscastBlockDialyContentTemplate;
export type BroadscastBlockShort = WebApi.BroadscastBlockShort;
export type AssignBlockToBroadcastResult = WebApi.AssignBlockToBroadcastResult;
export type BroadcastItemAutoDTO = WebApi.BroadcastItemAutoDTO;
export type BroadcastAutoDTO = WebApi.BroadcastAutoDTO;
export type BroadcastItemChange = WebApi.BroadcastItemChange;
export type ActionType = WebApi.ActionType;
export type ServerUsageData = WebApi.ServerUsageData;
export type ServerTimeResponse = WebApi.ServerTimeResponse;
export type StatisticsAggregationType = WebApi.StatisticsAggregationType;
export type StatisticGetDTO = WebApi.StatisticGetDTO;
export type StatisticGetByDayDTO = WebApi.StatisticGetByDayDTO;
export type StatDataSendDto = WebApi.StatDataSendDto;
export type StatisticDeviceActivityGetDTO = WebApi.StatisticDeviceActivityGetDTO;

